const translation = {
    'login_mfa': 'Ik heb een MFA token',
    'edit': 'Aanpassen',
    'stop_edit': 'Stop aanpassen',
    'destination': 'Bestemming',
    'choose_a_destination': 'Kies een gebied om de doelen naar te verplaatsen',
    'move': 'Verplaats',
    'subjects': 'Leerdoelen | Leerdoel',
    'topics': 'Deelgebieden | Deelgebied',
    'start_typing': 'Beginnen met typen',
    'today': 'Vandaag',
    'yesterday': 'Gisteren',
    'no_date': 'Geen datum',
    'anonymous': 'Anoniem',
    'hide_roster': 'Digitale Klassenmap',
    'download_teacher_error_title': 'Selecteer een school',
    'download_teacher_error_text': 'Selecteer ten minste één school om de leraar gegevens van te downloaden.',
    'teachers_data': 'Download leraargegevens',
    'users': 'Gebruiker | Gebruikers',
    'role': 'Rol | Rollen',
    'system': 'Systeem',
    'reset_password': 'Wachtwoorden instellen',
    'password': 'Wachtwoord',
    'create_new_user': 'Maak een nieuwe gebruiker aan',
    '{count} goal selected|{count} goals selected': '{count} doel geselecteerd|{count} doelen geselecteerd',
    'toStudent': 'Naar {item}',
    'grade': 'Leerjaar',
    'choose_level': 'Kies een niveau',
    'choose_period': 'Kies een periode',
    'changed from': 'gewijzigd van',
    'to': 'naar',
    'global_user': {
        role: 'Global User | Global Users',
    },
    'navigation': {
        scoolcore: 'MijnBasis',
        scooladmin: 'MijnInstellingen',
        roster: 'MijnRooster',
    },
    'trashed': {
        title: 'Verwijderde leerdoelen',
    },
    'Show inactive items': 'Toon ook verwijderde leerdoelen',
    'Only show active items': 'Toon alleen actieve leerdoelen',
    'students': {
        tab: {
            school_tracker_description: 'Stukje tekst over Mijn PLP',
            this_is_me_description: 'Stukje tekst over Persoonlijk',
            portfolio_description: 'Stukje tekst over Mijn Drive',
            levels_description: 'Stukje tekst over Niveaus',
            profile_description: 'Stukje tekst over Profiel',
            messages_description: 'Stukje tekst over Berichten',
            notes_description: 'Stukje tekst over Notities',
            treatment_description: 'Stukje tekst over Ondersteuning',
            lvs_description: 'Stukje tekst over LVS',
            finished_description: 'Stukje tekst over Successen',
            roster_description: 'Stukje tekst over Mijn Rooster',
            plan: 'Stukje tekst over Documenten',
        },
    },
    'deleted': 'Verwijderd',
    'delete': 'Verwijderen',
    'report': {
        no_areas: 'Er zijn geen Hoofdgebied gemaakt',
        no_areas_subtext: 'Je kunt naar Curriculum > Nieuw Hoofdgebied gaan om er een te maken.',
        target: 'Uitstroom',
        reference_level: 'Waarde (niveauwaarde, percentielscore etc.)',
        period: 'Toets',
        date: 'Datum',
        score: 'LVS score (I t/m V of A t/m E)',
        choose_filter: 'Pas de bovenstaande filters eerst toe om informatie weer te geven.',
        headers: {
            group: 'Groep',
            lvs: 'Analyse',
        },
        sub_headers: {
            prev_period: 'Vorige Toets',
            curr_period: 'Huidige Toets',
            notes: 'Notities',
            target: 'Uitstroom / Ambitie',
        },
    },
    'auth': {
        login: 'Inloggen',
        set_mfa_page: 'MFA instellen',
        invalid: 'De combinatie van gebruikersnaam en wachtwoord is niet bekend. Probeer het nog een keer.',
        logout: 'Uitloggen',
        forgot: {
            title: 'Wachtwoord vergeten',
            instruction: 'Ouders en leerkrachten kunnen hier een nieuw wachtwoord opvragen. Voer je e-mailadres in en ontvang een mail om een nieuw wachtwoord aan te maken. Leerlingen kunnen zich melden bij de leraar.',
            submit: 'Zoeken',
            contact: 'Neem contact op met je schoolbeheerder om je wachtwoord opnieuw in te stellen.',
            login: 'Nog geen login? Klik hier',
        },
        reset: {
            title: 'Wachtwoord resetten',
            instruction: 'Maak een nieuw wachtwoord aan',
            submit: 'reset',
        },
        submitted: {
            success: 'Gelukt!',
            sent: 'We hebben een mail gestuurd aan {email}.',
            again: 'Log opnieuw in',
        },
        password: 'wachtwoord',
        confirm_password: 'Bevestig wachtwoord',
        no_match: 'De wachtwoorden komen niet overeen',
        required: 'Wachtwoord is verplicht',
        mfa: 'MFA Token',
        mfa_title: 'Multi-factor authentication instellen',
    },
    'goalsetSelect': {
        title: 'Toon doelensets',
        showGoalsetOnly: 'Doelen uit doelensets',
        showAll: 'Alle doelen',
        showStudentGoalsOnly: 'Doelen gekoppeld aan leerlingen',
        periodeplanPlaceholder: 'Kies periodeplan',
    },
    'dashboard': {
        title: 'MijnDashboard',
        welcome: 'Welkom {name}',
        intro: 'Wat leuk dat je er weer bent.',
        finished: 'Deze periode behaalde {item}',
        guardianNoData: 'De school heeft op dit moment nog geen informatie voor ouders beschikbaar gesteld. Zodra er gegevens worden gedeeld, verschijnen deze hier.',
        guardianIntroTitle: 'Informatie over uw kind bekijken',
        guardianIntroText: 'Klik links op de naam van uw kind om de informatie te openen die door de school beschikbaar is gesteld.',
    },
    'roster': {
        title: 'Schoolrooster',
        planner: 'MijnRooster instellingen',
        preplanner: 'Preplanner',
        preplannerExplanation: 'De pre-planner zal alle leerlingen met 1 verplichte les of maar 1 keuze les per tijdslot automatisch inplannen voor die les voor de opgegeven periode. Indien een leerling door de pre-planner is ingepland op een les, kan dat niet meer door een nieuwe pre-planner taak ongedaan worden gemaakt. Wil je dit wel ongedaan maken, zul je eerst de pre-run moeten draaien voordat je de pre-planner opnieuw uitvoert.',
        autoplanner: 'Autoplanner',
        attention: 'LET OP!',
        prerun: 'Prerun',
        preRunExplanation: 'Met de pre-run reset je de opgegeven periode. Dat wil zeggen dat alle eventuele reeds gemaakte keuzes van leerlingen worden verwijderd. Op basis van de instellingen en doelen per les, wordt vervolgens bepaald welke leerlingen voor welke lessen worden uitgenodigd.',
        start: 'Start',
        clickHere: 'Klik hier',
        runTime: 'Het duurt minimaal 30 minuten tot de autoplanner voltooid is.',
        autoplannerExplanation: 'Op dit tijdstip wordt voor alle leerlingen het rooster automatisch afgemaakt. Voor alle lessen waar nog geen keuze is gemaakt door de leerling, maakt de computer die.',
        autoplannerExplanation_2: 'De autoplanner probeert voor alle leerlingen die nog een keus hebben een keus te maken. De autoplanner houdt rekening met een aantal regels (zoals de capaciteit van een lokaal). Het kan dus voorkomen dat niet alle leerlingen aan een les gekoppeld kunnen worden.',
        softLock: 'Soft-lock',
        softLockExplanation: 'Alleen de lestijden van alle lessen vóór en op deze datum kunnen niet meer worden aangepast. De inhoud van de lessen kan door leraren wél nog worden aangepast. Leerlingen kunnen wél lessen kiezen.',
        hardLock: 'Hard-lock',
        hardLockLockExplanation: 'De lesinhoud en lestijden van alle lessen vóór en op deze datum kunnen niet meer worden aangepast. Leerlingen kunnen ook geen lessen meer kiezen.',
        visibleTeacher: 'Zichtbaarheid Leraar',
        visibleTeacherExplanation: 'Alle lessen vóór en op deze datum zijn zichtbaar voor de leraar. Alle lessen ná deze datum zijn niet zichtbaar voor de leraar.',
        visibleStudent: 'Zichtbaarheid Leerling',
        visibleStudentExplanation: 'Alle lessen vóór en op deze datum zijn zichtbaar voor de leerling. Alle lessen ná deze datum zijn niet zichtbaar voor de leerling.',
        autoPlannerWeekInterval: 'Auto planner week interval',
        autoPlannerWeekIntervalExplanation: 'Stel hier in hoeveel weken de Autoplanner vooruit moet inplannen. Standaard is dit 1 week.',
        release_teacher: 'Vrijgeven aan leraren',
        release_teacherExplanation: 'Op dit tijdstip wordt het rooster automatisch vrijgegeven aan de leraren zodat zij de doelen kunnen koppelen aan de lessen. De roosterbeheerder kan vanaf dit moment de lestijden niet meer aanpassen.',
        release_student: 'Vrijgeven aan leerlingen',
        release_studentExplanation: 'Op dit tijdstip wordt het rooster automatisch vrijgegeven aan de leerlingen zodat zij keuzes kunnen maken voor lessen.',
        blockPlanner: 'Keuzes blokkeren',
        blockPlannerExplanation: 'Op dit tijdstip wordt het rooster automatisch dichtgezet voor leerlingen. Zij kunnen geen keus meer maken.',
        finalRoster: 'Rooster definitief',
        finalRosterExplanation: 'Op dit tijdstip wordt het rooster definitief gemaakt. Vanaf dit tijdstip kunnen de lestijden en lesinhoud niet meer worden aangepast. Leerlingen kunnen ook geen lessen meer kiezen.',
        settings: 'Rooster instellingen',
        settingsWeek: 'Weekinstellingen rooster',
        settingsGeneral: 'Huidige roosterwaarden',
        myRoster: 'Rooster',
        myLessons: 'Mijn lessen',
        hours: 'Vaste werktijden',
        workHours: 'Werktijden',
        calendar: 'Afwezigheid per week',
        dialog: {
            subjects: 'Leerdoel(en)',
            lessonType: 'Lestype',
            overview: 'Overzicht',
            select: 'Selecteer',
            addComment: 'Laat een notitie voor de leerlingen achter in het rooster',
            lessonMandatory: 'Les overzicht',
            amountOfStudents: 'Aantal leerlingen',
            invite: 'Keuze',
            invited: 'Keuze',
            mandatoried: 'Verplicht',
            mandatory: 'Leerlingen & doelen overzicht',
            is_default: 'Les voorwaarden',
            notMandatoried: 'Keuze',
            mandatoryErrorTitle: 'Les kan niet worden gekozen',
            mandatoryErrorMessage: 'Je kunt die keuze niet maken, omdat je op dat moment al een verplichte les (gekozen) hebt.',
            sameLevelNotFinished: 'Zit in deze les en heeft het leerdoel nog actief',
            sameLevelFinished: 'Zit in deze les en heeft het leerdoel al behaald',
            notSameLevelPLP: 'Zit niet in deze les maar heeft het leerdoel wel actief',
            others: 'Zit niet in deze les',
            selectOtherStudents: 'Nodig andere leerlingen uit',
            lessonOverview: 'Les overzicht',
            description: 'Omschrijving',
            mandatoryAndInvitation: 'Verplicht en keuze',
            edit: 'Pas les aan',
            noSubjects: 'Geen leerdoel(en) geselecteerd',
            noLessonType: 'Geen lestype geselecteerd',
            inviteExtra: 'Andere leerlingen uitnodigen',
        },
        activities: 'activiteit | activiteiten',
        lessons: 'les | lessen',
        information: {
            title: 'Rooster informatie',
            red: 'Deze les is niet meer aan te passen.',
            blue: 'Hier is geen keuze.',
            orange: 'Er is nog geen les gekozen.',
            green: 'Een les is gekozen.',
        },
    },
    'tool': {
        title: 'MijnRooster',
        buttons: {
            subject: 'Doelen overzicht',
            presence: 'Aanwezigheid',
            students: 'Leerlingen',
            edit_class: 'Les bewerken',
            logbook: 'Logboek',
        },
        alert: {
            text: 'Er zijn geen lessen gevonden voor de geselecteerde dag.',
            subtext: '',
        },
        search: 'Zoek een ander rooster',
        sync: {
            message: 'Klik op de knop om voor iedereen zijn laatste rooster op te halen.',
            in_progress: 'Op dit moment wordt er een opdracht uitgevoerd. Zodra deze klaar is kunt u weer synchroniseren',
            warning: 'Het kan 5 minuten duren voordat iedereen zijn nieuwe rooster ziet',
            button: 'Sync MijnRooster',
        },
    },
    'notifications': {
        title: 'MijnBerichten',
        title_overview: 'MijnBerichten geschiedenis',
        today: 'Vandaag',
        alert: {
            text: 'Geen berichten',
            subtext: 'Je hebt nog geen berichten ontvangen.',
        },
        delete: 'Markeer selectie als gelezen',
        delete_all: 'Markeer alles als gelezen',
        message: {
            content: 'heeft een bericht geplaatst op',
            at: 'op',
        },
        view_all: 'Bekijk alle berichten',
        tabs: {
            chat: 'Leerling pagina',
            plp: '   pop-up',
            group: 'Groep chats',
            subject: 'Leerdoelen',
            new_chat: 'Nieuwe berichten',
        },
        finished: {
            title: 'Leerdoel behaald!',
        },
    },
    'scoollinks': {
        title: 'MijnFavorieten',
        alert: {
            text: 'Geen MijnFavorieten',
            subtext: 'Je hebt nog geen MijnFavorieten aangemaakt.',
        },
        dialog: {
            create: {
                title: 'MijnFavorieten aanmaken',
                subtitle: 'MijnFavorieten aanmaken',
                submitting: 'MijnFavorieten wordt opgeslagen',
                submitted: 'MijnFavorieten is aangemaakt',
            },
            edit: {
                title: 'MijnFavorieten aanpassen',
                subtitle: 'MijnFavorieten aanpassen',
                submitting: 'MijnFavorieten wordt opgeslagen',
                submitted: 'MijnFavorieten is aangepast',
            },
            delete: {
                title: 'MijnFavorieten verwijderen',
                subtitle: 'MijnFavorieten verwijderen',
                text: 'Weet je zeker dat je dit wilt verwijderen?',
            },
        },
    },
    'back': 'Terug',
    'search': 'Zoeken',
    'avatar': {
        title: 'Profielfoto',
        change: 'Wijzig foto',
    },
    'name': {
        title: 'Naam',
        first: 'Voornaam',
        middle: 'Tussenvoegsel',
        last: 'Achternaam',
    },
    'age': {
        title: 'Leeftijd',
    },
    'profile': {
        parnassys: {
            title: 'Parnassys',
            placeholder: 'Enter parnassys id',
            label: 'Parnassys ID',
        },
        title: 'Profiel',
        setting: 'Instelling',
        mine: 'Mijn Profiel',
        standard: 'Standaard Informatie',
        contact: {
            information: 'Contact Informatie',
            person: 'Contactpersoon',
            number: 'Contactnummer',
        },
        tag: {
            information: 'Type Leerling',
        },
        extra: 'Medische Informatie',
        dob: 'Geboortedatum',
        guardians: 'Ouders/Verzorgers',
        students: 'Leerlingen',
        email: 'Email',
        phone: 'Telefoon',
        allergy: 'Allergie | Allergieën',
        medicine: 'Medicijn | Medicijnen',
        password: {
            title: 'Nieuw wachtwoord',
            forgot: 'Wachtwoord vergeten?',
            confirm: 'Bevestig wachtwoord',
            change: 'Verander wachtwoord',
        },
        group: 'Groep',
        groups: 'Groepen',
        login: 'Login als',
        level: {
            title: 'Niveau',
            information: 'Niveau informatie',
        },
        finished: {
            title: 'Successen',
        },
        parnassys_group: 'Parnassysgroep',
        coach: 'Coachgroep',
        room: 'Lokaal',
        class: 'Stamgroep',
        url: 'Url',
        language: 'Taal',
        type: 'Type',
        address: 'Adres',
        street: 'Straat',
        housenumber: 'Huisnummer',
        addition: 'Toevoeging',
        zipcode: 'Postcode',
        city: 'Plaats',
        rotateImage: 'Roteer geselecteerd afbeelding',
        project: 'Doelenset',
        my_subject_overview: 'Naar mijn doelen overzicht',
        add_support: 'Voeg ondersteuning toe',
    },
    'library': {
        title: 'Bibliotheek',
    },
    'curricula': {
        title: 'Alle curricula',
        add: 'Voeg curriculum toe',
        form: {
            upload: 'Klik hier om een curriculum te uploaden',
            uploading: 'We zijn druk bezig het curriculum te uploaden....',
            problem: 'Er is een fout geconstateerd',
            hint: {
                p1: 'Om een curriculum te uploaden moet hij in een vast format zijn, Download deze hier:',
                p2: '',
            },
            redirect: 'Zodra je curriculum "{name}" geupload is, wordt hij geopend',
            moment: 'Nog even wachten...',
            error: 'Het uploaden van je curriculum duurt iets langer als normaal, we kijken of er iets fout kan zijn gegaan.',
            support: 'Probeer het nog een keer, als het weer niet lukt maak dan een Helpdesk ticket aan.',
        },
        searchDialog: {
            title: 'Leerdoel zoeken',
            placeholder: 'Zoek leerdoel',
            selected_title: 'Geselecteerde leerdoelen',
            headers: {
                area: 'Hoofdgebied',
                subject: 'Leerdoel',
                level: 'Niveau',
                period: 'Periode',
                actions: 'Acties',
            },
            actions: {
                apply: 'Toepassen',
            },
        },
    },
    'curriculum': {
        title: 'Curriculumoverzicht',
        import: {
            area: {
                title: 'Importeer Hoofdgebied/Deelgebied en Leerdoelen',
                header: 'Nieuw hoofdgebied | Nieuw hoofdgebieden',
                success: 'Het nieuwe hoofdgebied is aan je curriculum toegevoegd',
            },
            topic: {
                title: 'Importeer Deelgebied en Leerdoelen voor een specifiek Hoofdgebied',
                header: 'Importeer Deelgebied |  Importeer Deelgebieden',
                success: 'Het nieuwe deelgebied is aan je curriculum toegevoegd',
            },
            subject: {
                title: 'Importeer Leerdoelen voor een specifiek Deelgebied',
                header: 'Importeer Leerdoelen |  Importeer Leerdoelen',
                success: 'De nieuwe doelen zijn aan je curriculum toegevoegd',
            },
        },
        area: {
            exclude: {
                button: 'Niet meenemen in PLP',
                message: "Weet u zeker dat u dit gebied wilt uitsluiten van de automatisch gegenereerde PLP's?",
            },
            include: {
                button: 'Meenemen in PLP',
                message: "Weet u zeker dat u dit gebied wilt opnemen in de automatisch gegenereerde PLP's?",
            },
            periodChange: {
                button: 'Negeren bij periodewissel',
                ignoreStatus: {
                    title: 'Status van doelen niet aanpassen bij periodewissel',
                    button: 'Ja, status niet aanpassen',
                    message: 'Bij een periodewissel worden de statussen van de doelen van dit hoofdgebied niet aangepast / genegeerd. Weet u het zeker?',
                },
                updateStatus: {
                    title: 'Status van doelen aanpassen bij periodewissel',
                    button: 'Ja, status aanpassen',
                    message: 'Bij een periodewissel worden de statussen van de doelen van dit hoofdgebied aangepast. Weet u het zeker?',
                },
            },
            enableWorksheet: {
                button: 'Genereerbaar werkblad',
                message: 'Geeft gebruikers de optie om een werkblad te genereren.',
                cancel: 'annuleren',
                enable: 'Werkblad generatie inschakelen',
                disable: 'Werkblad generatie uitschakelen',
            },
        },
        topic: {
            add: 'Voeg een deelgebied toe',
        },
        subject: {
            add: 'Voeg leerdoelen toe',
            rating: 'Starts',
        },
        newSubject: {
            title: 'Maak een nieuw',
            select: {
                areaColor: 'Selecteer de kleur van je nieuwe hoofdgebied',
                areaIcon: 'Selecteer een icoon voor het nieuwe hoofdgebied',
            },
            placeholder: 'Maak een {item} aan',
            create: 'Opslaan',
            selectFilter: {
                level: 'Kies een niveau',
                period: 'Kies een periode',
            },
        },
        alert: {
            text: 'Dit curriculum heeft nog geen Hoofdgebieden.',
            subtext: 'Je kan een Hoofdgebied toevoegen door op de knop te drukken.',
        },
        total: {
            getAll: 'Totale is opgehaald',
        },
    },
    'mfa': {
        remove: {
            title: 'Multi-factor authenticatie',
            descriptionTrue: 'Druk op de knop om de MFA opnieuw in te kunnen stellen.',
            descriptionFalse: 'Deze gebruiker heeft geen MFA ingesteld.',
            button: 'Reset MFA',
        },
        dialog: {
            remove: {
                title: 'MFA resetten',
                text: 'Weet je zeker dat je de MFA voor {name} wilt resetten?',
            },
        },
    },
    'user': {
        add: '{item} toevoegen',
        deleted_students: 'Verwijderde leerlingen tonen',
        all_students: 'Alle leerlingen tonen',
        restore: 'Leerling herstellen',
    },
    'level': {
        title: 'Niveau | Niveaus',
        title2: 'MijnLeerlijn',
        create: 'Nieuw niveau aanmaken',
        placeholder: {
            name: 'Niveau naam',
            value: 'Niveau waarde',
            sequence: 'Niveau sequence',
        },
    },
    'subject_label_category': {
        all: 'Alle Leerdoel categorieën',
        add: '{item} toevoegen',
        title: 'Leerdoel categorie | Leerdoel categorieën',
        title2: 'Leerdoel categorie | Leerdoel categorieën',
        create: 'Nieuwe categorie aanmaken',
        update: 'Categorie aanpassen',
        placeholder: {
            name: 'Leerdoel categorie naam',
        },
    },
    'subject_label': {
        all: 'Alle Leerdoel tags',
        add: '{item} toevoegen',
        title: 'Leerdoel tag | Leerdoel tags',
        title2: 'Leerdoel tag | Leerdoel tags',
        create: 'Nieuwe Leerdoel tag aanmaken',
        update: 'Leerdoel tag aanpassen',
        placeholder: {
            name: 'Leerdoel tag naam',
        },
    },
    'period': {
        title: 'Periode | Perioden',
        create: 'Nieuwe periode aanmaken',
        add: '{item} toevoegen',
        information: 'Periode informatie',
        placeholder: {
            name: 'Periode naam',
            value: 'Periode waarde',
        },
    },
    'group': {
        title: 'MijnGroep | MijnGroepen',
        all: 'Alle Groepen',
        mine: 'Mijn Groepen',
        student: 'Leerling | Leerlingen',
        teacher: 'Leraar | Leraren',
        guardian: 'Ouder | Ouders',
        projectPlan: 'DoelensetPlan',
        type: 'Groeptype | Groeptypes',
        amountOfStudents: 'Aantal leerlingen',
        idpGroup: 'PLP Overzicht',
        profile_title: 'Groepsinformatie',
        report: 'Analyse',
        deleted_groups: 'Verwijderde groepen tonen',
        all_groups: 'Alle groepen tonen',
        restore: 'Groep herstellen',
        types: {
            fixed: 'Roostergroep',
            class: 'Stamgroep',
            coach: 'Coachgroep',
            project: 'Projectgroep',
            parnassys: 'Parnassys',
        },
        add: '{item} toevoegen',
        dialog: {
            select: 'Selecteer een {type} die je aan deze groep wilt toevoegen.',
            selected: 'Geselecteerde',
        },
        select: 'Selecteer groep type',
        placeholder: 'Kies groep',
        addSubject: {
            choose: 'Kies leerdoel(en)',
            chooseSubText: 'Kies leerdoel(en) om toe te voegen aan de groep',
            confirm: 'Bevestig de leerdoel(en) voor de groep',
            confirmSubText: 'Wil je deze leedoel(en) aan de groep toevoegen?',
            created: 'Je hebt nieuwe leerdoelen aan de groep toegevoegd',
        },
        errors: {
            noStudents: {
                description: 'De huidige groep bevat nog geen leerlingen met doelen.',
                suggestion: 'Voeg een paar leerdoelen toe aan leerlingen in deze groep, of maak een andere selectie.',
            },
        },
        newFromStudents: {
            add: 'Nieuwe MijnGroep aanmaken',
        },
    },
    'documents': {
        title: 'MijnDocumenten',
        label: 'Document | Documenten',
        name: 'Document naam',
        connection: 'Groep of leerling',
        object_info: {
            user: 'Leerling',
            group: 'Groep',
        },
        connectionName: 'Naam groep of leerling',
        selectPlaceholder: 'Kies groep of leerling',
        group: 'Groep',
        student: 'Leerling',
    },
    'year': {
        title: 'Jaar | Jaren',
        all: 'Alle Jaren',
        create: 'Nieuw schooljaar aanmaken',
        starts: 'Start',
        ends: 'Eind',
        value: 'Waarde',
        noCurriculum: '',
        active: 'Actief',
        inactive: 'Inactief',
        information: 'Jaar informatie',
        add: '{item} toevoegen',
    },
    'tag': {
        title: 'School | Scholen',
        all: 'Alle Scholen',
        add: '{item} toevoegen',
        create: 'Nieuwe school toevoegen',
        placeholder: 'Selecteer school',
    },
    'room': {
        title: 'Lokaal | Lokalen',
        all: 'Alle Lokalen',
        add: 'Add room',
        placeholder: 'Selecteer lokaal',
        maxCapacity: 'Maximum capaciteit',
        color: 'Kleur',
        lessonTypes: 'Les types',
        addLessonType: 'Voeg les type toe',
        levels: 'Niveaus',
        addLevels: 'Voeg niveau toe',
        dialog: {
            create: 'Voeg een lokaal toe',
            edit: 'Wijzig lokaal',
            type: 'Les type',
            capacity: 'Capaciteit',
            color: 'Selecteer een kleur voor het nieuwe lokaal',
            editColor: 'Wijzig de kleur van het lokaal',
        },
        button: {
            add: 'Toevoegen',
            edit: 'Wijzigen',
        },
    },
    'lessonType': {
        title: 'Les type | Les types',
        all: 'Alle les types',
        button: {
            add: 'Voeg toe',
            edit: 'Pas aan',
        },
        dialog: {
            add: 'Les type',
            edit: 'Pas les type aan',
            icon: 'Les type icoon',
        },
    },
    'school_tools': {
        parnassys: {
            sync_teachers_button: 'Leraren Synchroniseren',
            sync_parents_button: 'Synchroniseer Ouders',
            sync_students_button: 'Studenten Synchroniseren',
            sync_message_warn: 'Let op: het brinnummer van Parnassys dient ingevuld te zijn in Mijn School -> Instellingen.',
            sync_message: 'Klik op de knop om de leerling, leraar en groepinformatie te synchroniseren met de data van Parnassys.',
            title: 'Synchroniseer met Parnassys',
        },
    },
    'school': {
        title: 'Klant | Klanten',
        myschool: 'School instellingen',
        hide_roster: 'Digitale Klassenmap',
        tools: 'Tools',
        roster: 'MijnRooster instellingen',
        settings: 'Instellingen',
        lvs_settings: 'Analyse Instellingen',
        group_settings: 'Groep Instellingen',
        logbook: 'Logboek',
        parnassys_title: 'Parnassys',
        mfa_title: 'MFA',
        holiday: 'Vakanties',
        templates: 'Week sjablonen',
        management: 'Schoolrooster',
        openingHours: 'Openingstijden',
        select: 'Selecteer een klant',
        all: 'Alle Klanten',
        add: '{item} toevoegen',
        version: 'Versie',
        mail_settings: 'Email instellingen',
        create: {
            title: 'Maak een nieuwe:{role}',
            description: 'Maak een nieuwe {role} aan met zijn eigen omgeving.',
            logo: {
                title: '{role} logo',
                small: '{role} logo (klein)',
            },
            address: {
                title: 'Extra gegevens',
                text: 'Vul hier het adres in en contact gegevens',
                address: 'Adres gegevens',
                street: 'Straat',
                number: 'Nummer',
                add: 'Toevoeging',
                zipcode: 'Postcode',
                city: 'Stad',
                contact: 'Contact gegevens',
            },
            confirm: {
                title: 'Bevestig de gegevens',
                text: 'Bevestig of alle gegevens juist zijn van de nieuwe {role}.',
                school: 'Klant gegevens',
                locales: {
                    title: 'Land',
                    nl: 'Nederland',
                },
                languages: {
                    title: 'Taal',
                    nl: 'Nederlands',
                    en: 'Engels',
                    vo: 'Vrije school',
                },
                address: 'Adres gegevens',
                contact: 'Contact gegevens',
            },
            finished: {
                title: '{role} aangemaakt',
                description: 'Wij hebben jouw nieuwe {role} aangemaakt.<br>Je kan inloggen met de gegevens beneden.<br>De school is beschikbaar met de URL voor jouw omgeving.',
            },
        },
        lvs_setting: {
            areas_title: 'Hoofdgebieden',
            periods_title: 'Analyse Moment',
            period_create_title: 'Nieuwe periode aanmaken',
            period_level_placeholder: 'Voer een niveau in tussen 1 en 8',
        },
        placeholder: 'Selecteer school type',
    },
    'rosterTemplate': {
        title: 'Week sjabloon | Week sjablonen',
        add: 'Voeg week toe',
        save: 'Sla week op',
        createdAt: 'Aangemaakt op',
        updatedAt: 'Gewijzigd op',
        start: 'Start van de week',
        dialog: {
            header: {
                activities: 'Les | Lessen',
                teachers: 'Leraren',
                areas: 'Hoofdgebieden',
                area: 'Hoofdgebied',
                topics: 'Deelgebieden',
                rooms: 'Lokalen',
                levels: 'Niveaus en vaste groepen',
                overview: 'Overzicht',
                finished: 'Finished',
            },
            activities: 'Tijdslot overzicht',
            teachers: 'Selecteer een leraar',
            areas: 'Selecteer een hoofdgebied',
            selectedArea: 'Geselecteerde hoofdgebied',
            topics: 'Selecteer een deelgebied',
            allTopics: 'Alle deelgebieden',
            rooms: 'Selecteer een lokaal',
            levelAndGroup: 'Selecteer niveaus en/of groepen',
            level: 'Selecteer een niveau',
            overview: 'Overzicht',
            addActivity: 'Voeg een les toe',
            addBreak: 'Voeg een pauze toe',
            remove: 'Verwijder gehele tijdslot',
            create: 'Maak een les aan',
            teacherMessage: 'Bij het aanmaken van een les kun je alleen een leraar selecteren waarvoor nog geen les is ingepland.',
            roomMessage: 'Bij het aanmaken van een les kun je alleen een lokaal selecteren waarvoor nog geen les is ingepland.',
            mandatoryMessage: 'Verplichte niveaus en groepen zijn rood gekleurd.',
            roomFullMessage: 'De geselecteerde level/groep heeft te veel studenten om in het lokaal te passen | De geselecteerde levels/groepen hebben te veel studenten om in het lokaal te passen',
            doublePeriodMessage: 'Blokuren hebben een blauw streep naast de les regel.',
            message: '',
            mandatory: {
                levels: {
                    checkbox: 'Maak verplicht voor alle bovenstaande niveaus',
                    overview: 'Deze niveaus zijn verplicht',
                },
                groups: {
                    checkbox: 'Maak verplicht voor alle bovenstaande groepen',
                    overview: 'Deze groepen zijn verplicht',
                },
            },
            created: 'Les is gemaakt',
            updated: 'Les is aangepast',
            createTimeslot: 'Maak een nieuw tijdslot',
            timeslotTitle: 'Tijdslot titel',
            startsAt: 'Begint met',
            endsAt: 'Eindigt met',
            doublePeriod: 'Blok uur',
            doublePeriodLabel: 'Maak van deze les een blokuur',
            selectDoublePeriod: 'Selecteer tot welk tijdstip dit blokuur moet lopen',
        },
        recess: 'Pauze',
    },
    'rosterManagement': {
        title: 'Rooster Management',
        buttons: {
            create: 'Rooster maken',
            release: 'Vrijgeven',
            unsafeMode: 'Schakel de onveilige modus in',
            safeMode: 'Schakel de veilige modus in',
            warning: 'waarschuwing | waarschuwingen',
            error: 'fout | fouten',
            studentsWithoutLessons: 'Leerlingen zonder les',
        },
        filter: {
            choose: 'Kies {type}',
        },
        unsafeMode: 'U zit in de onveilige modus',
        roster: 'Schoolrooster',
        today: 'Vandaag',
        dialog: {
            header: {
                selectDate: 'Selecteer startdatum en dan de duur van het rooster',
                assignRoster: 'Weken toewijzen',
                overview: 'Overzicht',
                success: 'Succes',
                studentsWithoutLessons: 'Leerlingen zonder les',
            },
            startDate: 'Start datum',
            amountOfWeeks: 'Aantal weken:',
            generating: 'Er wordt een rooster gegenereerd, dit kan een minuutje duren ...',
            generated: 'Gelukt, het rooster is gegenereerd',
            releaseRoster: 'Rooster vrijgeven',
            visibleForTeachers: 'Zichtbaar voor leraren',
            visibleForStudents: 'Zichtbaar voor leerlingen',
            softLock: 'Soft lock',
            hardLock: 'Hard lock',
        },
    },
    'time': {
        title: 'Tijd',
        start: 'Start tijd',
        end: 'Eind tijd',
        slot: 'Tijdslot',
        day: 'Dag',
    },
    'event': {
        title: 'Lessen',
        dialog: {
            create: 'Maak een nieuwe afspraak aan',
            edit: 'Pas afspraak aan',
            remove: 'Verwijder afspraak',
            choose: 'Kies een les',
            overview: 'Les overzicht',
            studentOverview: 'Studenten overzicht',
            subjectOverview: 'Doelen overzicht',
            title: 'Afspraak titel',
            recurring: 'Terugkerend afspraak',
            frequency: 'Kies',
            daily: 'Dagelijks',
            weekly: 'Wekelijks',
            monthly: 'Maandelijks',
            doublePeriod: 'Let op! Deze les is een blokuur.',
            noSubjectsSelected: 'Je hebt geen doelen geselecteerd bij stap 1.',
            noLessonTypeSelected: 'Je hebt geen lestype geselecteerd bij stap 2.',
            noDescription: 'Je hebt geen omschrijving toegevoegd bij stap 2.',
        },
        edit: {
            busyWithSameLevelOrGroup: 'Zit in deze les en heeft het leerdoel nog actief',
            completedWithSameLevelOrGroup: 'Zit in deze les en heeft het leerdoel al behaald',
            notSameLevelOrGroup: 'Zit niet in deze les maar heeft het leerdoel wel actief',
            notInPlp: 'Zit niet in PLP',
            totalUnique: 'Totaal unieke leerlingen',
            makeChoice: 'Maak tot keuze',
            visibleStudents: 'Deze les is al zichtbaar voor leerlingen en kan daarom niet meer worden aangepast.',
            hardlocked: 'Deze les bevindt zich voor of op de hard-lock datum en kan daarom niet meer worden aangepast.',
        },
        goToThisLesson: 'Ik wil naar deze les',
        lessonFull: 'Deze les is vol',
        chosenLesson: 'Ik heb deze les gekozen',
        total: 'Totaal uitgenodigde leerlingen',
        godmode: 'Kies uit alle lessen',
        godmodeOff: 'Terug naar het scherm van de leerling',
        godmodeChosen: 'Deze les is gekozen voor de leerling.',
    },
    'weekDays': {
        monday: 'maandag',
        tuesday: 'dinsdag',
        wednesday: 'woensdag',
        thursday: 'donderdag',
        friday: 'vrijdag',
        saturday: 'zaterdag',
        sunday: 'zondag',
    },
    'holiday': {
        title: 'Vakantie  | Vakanties',
        dialog: {
            title: 'Voeg een vakantie toe',
        },
        button: {
            add: 'Voeg toe',
            edit: 'Pas aan',
        },
    },
    'openingHours': {
        title: 'Schooltijden',
        startOfTheWeek: 'Begin van de week',
        plannerStart: 'Start planner',
        noTime: 'Geen tijd geselecteerd',
        noDay: 'Geen dag geselecteerd',
        selectedDay: 'Selecteer dag',
    },
    'area': {
        description: 'Hoofdgebied omschrijving',
        name: 'Hoofdgebied naam',
    },
    'subject': {
        title: 'Leerdoel | Leerdoelen',
        description: 'Omschrijving',
        rating: 'Sterren',
        deleted: 'een verwijderd doel',
        summary: {
            title: 'Overzicht Leerdoelen',
            chooseLevel: 'Stel bovenstaand filter eerst in, om het gekozen leerdoelen overzicht te zien.',
            noSubjects: 'Geen doelen gevonden.',
        },
        area: {
            title: 'Hoofdgebied | Hoofdgebieden',
        },
        topic: {
            title: 'Deelgebied | Deelgebieden',
        },
        dialog: {
            finishedNote: {
                placeholder: 'Leg uit hoe het doel behaald is.',
                warning: '*Attachments kunnen niet geupload worden naar de doelen die momenteel inactief zijn. Indien je inactieve doelen hebt geselecteerd moet je eerst de status van de doelen aanpassen.',
            },
            generalNote: {
                placeholder: 'Notitie',
            },
            achievedNote: {
                title: 'Stappen',
                placeholder: 'Leg uit wat voor de leerling de volgende stap is.',
            },
            addSubject: {
                title: 'Voeg leerdoel(en) toe',
                select: {
                    area: 'Selecteer hoofdgebied',
                    topic: 'Selecteer deelgebied',
                    goal: 'Selecteer leerdoel',
                    file: 'Selecteer bestand',
                    placeholder: 'Selecteer',
                },
                notFound: {
                    topic: 'Geen deelgebied gevonden',
                    goal: 'Geen leerdoel gevonden',
                },
                mode: 'Omgeving',
                status: 'Status',
                description: 'Omschrijving',
                upload: 'Uploaden',
                addedTo: 'Toegevoegd in',
            },
        },
        schedule: {
            title: 'Aanwezigheid',
            present: 'Aanwezig',
            absent: 'Afwezig',
            tardy: 'Te laat',
            sick: 'Ziek',
            approvedAbsence: 'Geoorloofd afwezig',
        },
        tab: {
            content: 'Inhoud',
            notes: 'Notities',
            template: 'Stappen',
            files: 'Bestanden',
            messenger: 'MijnMessenger',
            roster: 'MijnRooster',
            treatment: 'Ondersteuning',
            treatment_detail_page: 'Ondersteuning',
            lvs: 'Analyse',
            plan: 'Plan',
            worksheet: 'Mijn Werkblad (BETA Versie)',
            subtitle: {
                content: 'leerkracht',
                template: 'leerling',
                files: 'leerkracht',
                messenger: 'leerkracht',
                worksheet: 'leerkracht',
            },
        },
    },
    'schedule': {
        title: "Schema | Schema's",
        subject: 'Schema onderwerp',
        overview: 'Doelen overzicht',
    },
    'roles': {
        'user': 'MijnGebruikers | MijnGebruikers',
        'child': 'Kind | Kinderen',
        'student': 'Leerling | Leerlingen',
        'guardian': 'Ouder | Ouders',
        'teacher': 'Leraar | Leraren',
        'specialist': 'Roostermaker | Roostermakers',
        'supervisor': "IB'er | IB'ers",
        'trainer': 'Trainer | Trainers',
        'administrator': 'Beheerder | Beheerders',
        'root': 'Super Beheerder | Super Beheerders',
        'board-member': 'Roostermaker | Roostermakers',
        'manager': 'Bestuurder | Bestuurders',
    },
    'teacher': {
        add: 'Voeg leraar toe | Voeg leraren toe',
        subject: {
            title: 'Hoofdgebieden van deze leraar',
            dialog: {
                select: {
                    title: 'Alle hoofdgebieden',
                    subTitle: 'Kies het hoofdgebied(en) die door de leraar gegeven wordt',
                },
                confirm: {
                    title: 'Klopt dit?',
                    subTitle: 'Zijn dit de standaard hoofdgebieden die door deze leraar gegeven worden?',
                },
                finished: {
                    title: 'Klaar!',
                    subTitle: 'De hoofdgebieden zijn aan de leraar gekoppeld',
                },
            },
            noSubjects: 'Geen specifieke hoofdgebieden gevonden',
        },
    },
    'student': {
        add: 'Leerling toevoegen | Leerlingen toevoegen',
        redo_level: 'Afwijkende niveaus niet aanpassen',
        scoolfolio: 'MijnPortfolio',
        area: 'Hoofddoel',
        portfolio_archive: 'Portfolio archief',
        archive: {
            download_to_archive: 'Download portfolio naar archief',
            download_to_local: 'Download portfolio naar computer',
        },
    },
    'table': {
        found: '{total} {name} gevonden',
        perPage: '{name} per pagina',
        all: 'Alle {name}',
        noData: 'Geen gegevens beschikbaar',
        noStep: 'Geen stappen beschikbaar',
        maxCapacity: 'Maximum capaciteit',
        type: 'Type',
    },
    'errors': {
        loading: {
            description: 'Er is een probleem opgetreden bij het laden van de vereiste informatie.',
            suggestion: 'Probeer het later opnieuw of maak via de Helpdesk een ticket aan.',
        },
        notFound: {
            description: 'De door jouw opgevraagde pagina is niet gevonden.',
            suggestion: '404',
            url: 'Controleer de URL voor eventuele typefouten',
            error: '404 ERROR.',
            oops: 'Oeps :(',
            noSchool: 'De school die je probeert te bereiken bestaat niet.',
            or: 'of',
            contact: 'Neem contact met ons op via',
            signUp: 'om je te aanmelden bij MijnLeerlijn!',
        },
    },
    'idp': {
        title: 'MijnPLP',
        titleShort: 'MijnPLP',
        completedTotal: 'Je hebt {completed} van de {total} leerdoelen behaald',
        add: 'PLP toevoegen',
        add_skill_set: 'Vaardighedenset toevoegen',
        current: 'Huidig PLP',
        future: 'Komend PLP',
        dismissed: 'Niet van toepassing',
        active: 'Actief',
        project: 'Project',
        expandTopic: 'Open',
        collapseTopic: 'Dicht',
        filter: 'Filter',
        generate: {
            title: 'Genereer PLP',
            titleWithName: 'Genereer PLP van {name}',
            message: 'Klik op de knop om (aanpassingen in) huidig/komend PLP te genereren.',
            attention: '* Let op, hiermee wordt ook het huidige PLP geüpdatet',
            warning: 'Dit kan 5 minuten duren voordat het bij alle leerlingen zichtbaar is.',
            button: 'Genereren',
        },
        synchronize: {
            title: 'Synchroniseer doelensets',
            message: 'Klik op de knop om (aanpassingen in) huidig/komende doelensets te synchroniseren.',
            warning: 'Dit kan 5 minuten duren voordat het bij alle leerlingen zichtbaar is.',
            button: 'Synchroniseren',
        },
        delete: {
            title: 'Leerdoelen verwijderen van Persoonlijk LeerdoelenPlan (PLP)',
            message: "Via onderstaande acties worden leerdoelen met de gekozen status van alle PLP's verwijderd.",
            warning: 'Verwerkingstijd max. 5 minuten.',
            button: 'Leerdoelen status {status}',
        },
        reset: {
            warning: 'Dit kan tot 30 minuten duren.',
        },
        status: {
            busyHighlightedOld: 'Huidig, Uitgelicht & Oud',
            highlighted: '{highlighted} | Uitgelicht',
            busy: '{busy} | Huidig',
            old: '{old} | Oud',
            inactive: '{inactive} | Inactief',
            closed: '{closed} | Gesloten',
            finished: '{finished} | Behaald',
            future: '{future} | Komend',
            dismissed: '{dismissed} | N.v.t.',
        },
        treatment: {
            purple: '{purple} | Paars',
            teal: '{teal} | Groenblauw',
            blue: '{blue} | Blauw',
            yellow: '{yellow} | Geel',
            burgundy: '{burgundy} | Bordeaux rood',
            pink: '{pink} | Roze',
        },
        errors: {
            noGoals: {
                description: 'Je huidige Persoonlijk LeerdoelenPlan bevat nog geen doelen.',
                suggestion: 'Voeg een paar leerdoelen toe of maak een andere selectie.',
            },
        },
    },
    'progress': {
        title: 'Dit ben ik / Vaardigheden',
        placeholder: 'Voeg hier je eigen tekst...',
        label: {
            title: 'label | labels',
            header: 'Dit ben jij',
            new: 'Nieuw label',
        },
        interest: {
            title: 'interesse | interesses',
            header: 'Dit ben ik',
            new: 'Nieuw interesse',
        },
        photoalbum: {
            title: "foto | foto's",
            header: 'Foto album',
        },
        skill: {
            title: 'vaardigheid | vaardigheden',
            header: 'Vaardigheden',
            goals: 'Leerdoelen',
            new: 'Nieuwe vaardigheid',
            general: 'Persoonlijk',
        },
        result: {
            title: 'bestand | bestanden',
            header: 'Bestanden',
            table: {
                header: {
                    name: 'Naam',
                    description: 'Omschrijving',
                },
            },
        },
        dialog: {
            title: 'Updaten',
            subtitle: 'Weet je zeker dat je {item} wilt updaten?',
            uploadFile: 'Upload bestand',
            selectFile: 'Selecteer bestand',
            selected: 'gekozen',
        },
        button: {
            add: 'Voeg {item} toe',
            edit: 'Pas {item} aan',
        },
    },
    'portfolio': {
        title: 'MijnDrive',
        no_result: 'Geen bestanden gevonden',
        select: {
            area: 'Kies hoofdgebied',
            topic: 'Kies deelgebied',
        },
        dialog: {
            scoolPlan: 'sCoolPlan',
            title: 'Upload in MijnDrive',
            addGoal: 'Upload een bestand bij een leerdoel',
            addGoalDescription: 'Portfolio leerling',
            addOther: 'sCoolPlan: Upload informatie over de leerling',
            addOtherDescription: 'Dossier (alleen zichtbaar voor leerkrachten)',
            placeholder: {
                description: 'Omschrijving',
            },
            message: 'Je kunt bestanden tot 250MB uploaden',
            fileSizeExceededTitle: 'Bestand te groot.',
            fileSizeExceededMessage: 'Het bestand dat je probeert te uploaden is groter dan 250MB, probeer het bestand te verkleinen en upload het opnieuw.',
        },
        skills: {
            noValidCategories: 'Alle vaardigheden zijn toegevoegd aan het portfolio van deze student. U kunt een extra vaardighedenset maken op de pagina met vaardighedensets.',
            textSkillSets: 'Vaardigheden',
        },
        showOther: 'MijnPlan bestanden',
        document: 'document',
    },
    'actions': {
        notObligate: 'Niet verplichten',
        obligate: 'Wel verplichten',
        delete: 'Verwijder | Verwijderd',
        add: 'Voeg toe | Toegevoegd',
        edit: 'Pas aan | Aangepast',
        cancel: 'Stop | Gestopt',
        save: 'Opslaan | Opgeslagen',
        back: 'Terug',
        next: 'Volgende',
        close: 'Dicht',
        markAsSaved: 'Markeer als opgeslagen',
        markAsAchieved: 'Behaald',
        markAsNotAchieved: 'Niet behaald',
        markAsFinished: 'Klaar',
        markAsNotFinished: 'Niet klaar',
        needHelp: 'Hulp nodig',
        dontNeedHelp: 'Geen hulp nodig',
        assisted: 'Leerling geholpen',
        markAsBusy: 'Markeer als bezig',
        addAttachment: 'Voeg bijlage toe',
        send: 'Zoek',
        download: 'Download',
        upload: 'Upload',
        ok: 'Ok',
        reset: 'Reset',
        saveAndUpload: 'Opslaan en uploaden',
        getTotal: 'Aantallen inzien',
    },
    'chat': {
        title: 'Chat | Chats',
        subject: 'Doel | Doelen',
        message: 'MijnBerichten',
        attendees: 'Deelnemers',
        messageTo: 'Type hier je bericht (Zitten de juiste gebruikers in het gesprek?) ...',
        send: 'Verzenden',
        add: 'Gebruiker toevoegen',
        files: 'Bestanden',
        deleted: 'Dit bericht is verwijderd',
        regarding: 'Chat omtrent',
        group: {
            title: 'Groep | Groepen',
            studentGuardian: 'Leerling, Ouder(s) en Leraren',
            guardiansOnly: 'Ouder(s) en Leraren',
            teachersOnly: 'Alleen met Leraren (Intern)',
        },
    },
    'levels': {
        all: 'Alle Niveaus',
        download: {
            button: 'Download rapport',
            title: 'Rapport downloaden',
            description: 'Het rapport wordt momenteel klaargemaakt…',
        },
        toggleActive: 'Toon alleen actieve deelgebieden',
        add: '{item} toevoegen',
        topics: 'deelgebieden',
        grade: 'Niveau',
        changeGrade: 'Wijzig niveau',
        room: 'Lokaal',
        dialog: {
            title: 'Aanpassen',
        },
    },
    'projects': {
        navigation: {
            title: 'MijnDoelensets',
            all: 'Alle doelensets',
            mine: 'Mijn doelensets',
        },
        table: {
            name: 'Naam',
            description: 'Omschrijving',
            subjects: 'Leerdoelen',
        },
        tabs: {
            subjects: 'Leerdoelenoverzicht',
            media: 'Media',
            notes: 'Inhoud',
            project_plan: 'DoelensetPlan',
            files: 'Bestanden',
            messenger: 'MijnBerichten',
        },
        dialog: {
            steps: {
                info: 'Project informatie',
                subjects: 'Leerdoelen',
                subjects_confirm: 'Leerdoelen bevestigen',
            },
            info: {
                title: 'Maak een nieuwe Doelenset',
                name: 'Naam',
                description: 'Omschrijving',
            },
            subjects: {
                title: 'Leerdoelen toevoegen',
            },
            subjects_confirm: {
                title: 'Leerdoelen bevestigen',
            },
            create: 'Doelenset aanmaken',
        },
        select: {
            placeholder: 'Selecteer een Doelenset',
        },
        description: 'Omschrijving',
        title: 'Doelenset | Doelensets',
        all: 'Alle Doelensets',
        mine: 'Mijn Doelensets',
        add: '{item} toevoegen',
        no_project_alert_text: 'You are not yet connected to a project.',
        no_project_alert_subtext: 'Go to the profile page to link it.',
    },
    'student_plan': {
        template: {
            title_placeholder: 'Alinea titel',
            title_label: 'Titel',
            name_placeholder: 'Sjabloon naam',
            name_label: 'Naam',
            add_step: 'Alinea toevoegen',
            add_lvs: 'S/B factoren toevoegen',
            add_subjects: 'Uit PLP toevoegen',
            select: 'Kies een sjabloon (optioneel)',
            quill: 'Schrijf hier de inhoud van de alinea',
            all: 'Alle Sjablonen',
            create: 'Maak sjabloon',
            cancel: 'Annuleren',
            title: 'Sjabloon | Sjablonen',
            sidebar: 'Document Sjablonen',
        },
        table: {
            title: 'Titel',
            description: 'Omschrijving',
            start_at: 'Start Datum',
            end_at: 'Eind Datum',
            status: 'Status',
        },
        dialog: {
            steps: {
                one: 'Basis Informatie',
                two: 'Inhoud',
                three: 'Bestanden',
                teachers: 'Teachers',
            },
            one: {
                title: 'Maak nieuw document | Bewerk document',
                name: 'Naam',
                description: 'Omschrijving',
                quill: 'Geef een omschrijving over dit document',
            },
            two: {
                title: 'Document inhoud',
            },
            three: {
                title: 'Document bijlage(n)',
            },
            one_student: {
                title: 'Maak nieuw document | Bewerk document',
                name: 'Naam',
                description: 'Omschrijving',
                quill: 'Geef een omschrijving over dit document',
            },
            two_student: {
                title: 'Document inhoud',
            },
            three_student: {
                title: 'Document bijlage(n)',
            },
            save: 'Document opslaan | Document opslaan',
            start_date: 'Selecteer start datum',
            end_date: 'Selecteer eind datum',
            plan_status: 'Kies een status',
            is_visible_to_parents: 'Delen met ouders/verzorgers',
            is_visible_for_teachers: 'Delen met alle leraren (alleen inzien)',
            is_editable_for_teachers: 'Delen met alle leraren (bewerken en inzien)',
            select_teachers: 'Delen met leraren:',
            create: 'Maak sjabloon',
        },
        school_settings: {
            status_title: 'Document Statussen',
            dialog: {
                status_label: 'Status',
                status_placeholder: 'Status',
                title: 'Nieuwe Status',
                create: 'Aanmaken',
            },
        },
        status: {
            published: 'Gepubliceerd',
            concept: 'Concept',
        },
        description: 'Omschrijving',
        title_group: 'Document | GroepsDocumenten',
        title: 'Document | GroepsDocumenten',
        all: 'Alle Documenten',
        add: 'Document toevoegen',
        add_student: 'Document toevoegen',
    },
    'template': {
        placeholder: 'Stappen tekst',
    },
    'help': {
        title: 'Helpdesk',
    },
    'facts': {
        title: 'MijnFacts',
    },
    'starts': {
        title: 'Begin datum',
    },
    'stats': {
        title: 'MijnStats',
    },
    'feature': {
        title: 'New Features',
    },
    'absence': {
        title: 'Symbioseregeling',
        text: 'Voor scholen die voor de symbioseregeling administratie moeten bijhouden, kan je hier een uitdraai maken.',
        download: 'Wanneer je gebruik maakt van de Symbioseregeling, Download hier de statistieken',
    },
    'reset': {
        title: 'Reset periodes en niveaus',
        levels: {
            title: 'niveaus',
            text: 'Klik op de knop om alle afwijkende niveaus voor alle deelgebieden en alle leerlingen terug te zetten naar het hoofdniveau',
        },
        periods: {
            title: 'periodes',
            text: 'Klik op de knop om alle afwijkende periodes voor alle leerlingen terug te zetten naar de huidige standaard periode',
        },
    },
    'ends': {
        title: 'Eind datum',
    },
    'value': {
        title: 'Excel',
    },
    'sequence': {
        title: 'Sorteer',
    },
    'address': {
        country: 'Land',
        placeholder: 'Selecteer Land',
    },
    'language': {
        placeholder: 'Selecteer taal',
    },
    'userImportErrors': {
        101: 'Een Coachgroep bestaat niet',
        102: 'Een Stamgroep bestaat niet',
        201: 'Sommige verplichte excel velden zijn leeg',
        1000: 'Er is iets mis gegaan',
    },
    'component': {
        selectFilter: {
            placeholder: 'Kies',
            level: 'Niveau',
            subject_label: 'tags',
            period: 'Periode',
            block: 'Blok',
            group: 'Groep',
        },
    },
    'downloadDialog': {
        header: {
            title: 'Download leerdoelenboekje',
            description: 'Selecteer hoofdgebieden voor in het boekje en download de pdf.',
        },
        select: {
            label: 'Selecteer leerdoelen',
        },
    },
    'removeDialog': {
        header: {
            title: 'Verwijder leerdoelen uit PLP',
            description: 'Selecteer de hoofdgebieden die je wilt verwijderen.',
        },
        button: {
            select: 'Selecteer alle leerdoelen',
            removeAll: 'Verwijder allen',
            removeInProgress: 'Verwijder mee bezig',
            removeNew: 'Verwijder nieuw',
            removeOld: 'Verwijder oud',
        },
        successMessage: 'De geselecteerde leerdoelplannen zijn verwijderd.',
    },
    'createDialog': {
        header: {
            choose: 'Kies',
            import: 'Importeer',
            export: 'Exporteer',
            profile: 'Profiel',
            relationship: 'Relatie',
            confirm: 'Bevestig',
            finished: 'Klaar',
            explore: 'Leerlingen toevoegen',
            create: 'Groepsinformatie',
            address: 'Adres',
            select: 'Kies',
            merge: 'Groepen toevoegen',
            name: 'Naam',
        },
        choose: {
            title: 'Maak een {role} aan',
            text: 'Maak een {role} aan via een excel of los',
            options: {
                one: {
                    title: 'Upload .xsl bestand',
                    text: 'Voor één of meer {role}',
                },
                two: {
                    title: 'Maak een {role} profiel aan',
                    text: 'Voor één {role}',
                },
            },
        },
        profile: {
            title: 'Maak een {role} aan',
            text: 'Maak een nieuwe aan',
            upload: 'Upload een foto',
            click: 'Klik hier',
        },
        import: {
            title: 'Importeer {role}',
            text: 'Upload een Excel bestand',
            browse: 'Klik om een bestand te uploaden voor een {role}',
        },
        relationship: {
            title: 'Ouders',
            text: 'Kies een bestaande {role} of maak een nieuwe aan.',
            existing: 'Kies een bestaande {role}',
            create: 'Maak een nieuw {role} profiel aan',
            chosen: 'Gekozen {role}',
            or: 'of',
            save: 'Opslaan {role}',
            placeholder: 'Kies {role}',
        },
        confirm: {
            title: 'Bevestig de gegevens',
            text: 'Bevestig of alle informatie juist is voor de nieuwe {role}.',
            selected: 'Geselecteerde',
        },
        select: {
            curriculum: {
                title: 'Lopend Curriculum',
                text: 'Kies leerdoelen om toe te voegen aan het PLP.',
                confirmTitle: 'Bevestig de leerdoelen voor het PLP',
                confirmText: 'Wil je deze leedoelen aan het PLP toevoegen?',
                idpType: 'Aan welk PLP wil je deze leerdoelen toevoegen?',
                created: 'Je hebt nieuwe leerdoelen aan het PLP toegevoegd',
            },
        },
        finished: {
            title: 'Gelukt!',
            text: 'Je hebt een nieuwe {role} aangemaakt',
            password: 'De nieuwe gebruiker kan inloggen met dit wachtwoord:',
            imported: {
                part1: 'Je hebt geimporteerd',
                part2: 'nieuwe {role}.',
            },
            updated: '{role} is geupdate.',
            failed: {
                title: 'Deels gelukt',
                row: 'Rij',
                email: 'Email',
                field: 'Veld',
                missing_email: 'Onbekend',
                explainer: 'Het betreft de volgende',
                errors: {
                    email: 'Email',
                    dob: 'Geboortedatum',
                    first_name: 'Voornaam',
                    last_name: 'Achternaam',
                },
                part1: 'We konden niet uploaden',
                part2: '{role}',
            },
        },
        create: {
            title: 'Maak een nieuwe {role} aan',
            text: 'Koppel gebruikers aan een {role}.',
            type: 'Type | Types',
            placeholder: 'Selecteer {role} type',
        },
        explore: {
            title: 'Leerlingen toevoegen',
            text: 'Bekijk de gegeven en bevestig voor een {role}.',
        },
        merge: {
            title: 'Groepen toevoegen',
            text: 'Leerlingen uit deze groepen worden automatisch in je nieuwe groep geplaatst.',
        },
    },
    'dialogOptions': {
        item: {
            user: 'gebruiker',
            student: 'leerling',
            students: 'leerlingen',
            progress: 'Voortgang',
            teacher: 'leraar',
            guardian: 'ouder',
            area: 'hoofdgebied',
            message: 'bericht',
            subject: 'leerdoel',
            subjects: 'leerdoelen',
            treatment: 'Ondersteuning',
            topic: 'deelgebied',
            curriculum: 'curriculum',
            group: 'groep',
            level: 'niveau',
            period: 'periode',
            file: 'bestand',
            template: 'week sjabloon',
            step: 'stap',
            year: 'jaar',
            tag: 'school',
            school: 'klant',
            note: 'notitie',
            room: 'lokaal',
            lessonType: 'les type',
            lesson: 'les',
            activity: 'les',
            timeslot: 'tijdslot',
            project: 'project',
            helpAndFinished: 'hulp en afgerond status',
            plan: 'plan',
        },
        success: 'Success!',
        confirmation: 'Bevestiging',
        forbidden: 'Geen toegang',
        reset: 'Weet je zeker dat je {item} wilt resetten?',
        delete: 'Weet je zeker dat je dit {item} wilt verwijderen? | Weet je zeker dat je deze {item} wilt verwijderen?',
        deletePermanently: 'Weet je zeker dat je deze {item} definitief wil verwijderen?',
        deleteMany: 'Weet je zeker dat je deze {item} wilt verwijderen?',
        deleteMultiple: 'Weet je zeker dat je {amount} {item} wilt verwijderen?',
        deleteFromGroup: 'Weet je zeker dat je deze {item} uit de groep wil verwijderen?',
        notObligate: 'Weet je zeker dat je {item} niet wil verplichten voor deze les? | Weet je zeker dat je deze {item} niet wil verplichten voor deze les?',
        obligate: 'Weet je zeker dat je {item} wil verplichten voor deze les? | Weet je zeker dat je deze {item} wil verplichten voor deze les?',
        resetPeriods: 'Let op! Je gaat alle afwijkende periodes terugzetten naar de basis. Deze actie is niet ongedaan te maken!',
        resetLevels: 'Let op! Je gaat voor elke alle afwijkende niveaus terugzetten naar het hoofdniveau. Deze actie is niet ongedaan te maken!',
        sync_warning: 'Let Op! Weet u zeker dat u wilt synchroniseren met parnassys. Deze actie kan niet ongedaan gemaakt worden!',
        sync_warning_goals_sets: 'Let Op! Weet u zeker dat u de doelensets wilt synchroniseren? Deze actie kan niet ongedaan gemaakt worden!',
        init_warning: 'Weet je zeker dat je parnassys wilt initialiseren?',
        lesson: 'Weet je zeker dat je deze {item} wilt kiezen?',
        save: '{item} is opgeslagen',
        update: 'Weet je zeker dat je dit {item} wilt update? | Weet je zeker dat je deze {item} wilt updaten?',
        export: 'Weet je zeker dat je dit {item} wilt exporteren? | Weet je zeker dat je deze {item} wilt exporteren?',
        button: {
            delete: 'Verwijder',
            cancel: 'Nee dat wil ik niet',
            ok: 'Oke',
            reset: 'Resetten',
            yes: 'Ja',
        },
        switchedVersion: 'De school is veranderd naar versie {version}. Om de wijzigen toe te passen moet de pagina herladen worden',
        deleteBusyPLP: 'Let op! Deze actie verwijdert alle doelen met de status huidig, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Oude en uitgelichte doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteHighlightedPLP: 'Let op! Deze actie verwijdert alle doelen met de status uitgelicht, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Oude en huidige doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteOldPLP: 'Let op! Deze actie verwijdert alle doelen met de status oud, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Uitgelichte en huidige doelen blijven in het PLP staan. Deze actie is onomkeerbaar.',
        deleteCurrentPLP: "Let op! Deze actie verwijdert de huidige PLP's van leerlingen. Alle doelen, inclusief huidige, oude en uitgelichte doelen, worden verwijderd, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Deze actie is onomkeerbaar.",
        deleteFuturePLP: "Let op! Deze actie verwijdert komende PLP's van leerlingen. Alle doelen in een komend PLP worden verwijderd, ook als hier al iets aan is toegevoegd door leraren/leerlingen. Deze actie is onomkeerbaar.",
    },
    'swapDialog': {
        title: 'Wissel deelgebied',
        topic: 'Naam deelgebied',
        select: {
            area: 'Selecteer Hoofdgebied',
            topic: 'Selecteer Deelgebied',
        },
        placeholder: 'Kies een',
        swap: 'Wissel',
    },
    'importSubjects': {
        title: 'Importeer Hoofdgebied, Deelgebied en/of Leerdoelen',
        text: 'Importeer Hoofdgebied, Deelgebied en/of Leerdoelen uit een excel.',
    },
    'lvs': {
        title: 'Analyse instellingen',
        text: "Selecteer het gewenste analysemoment (midden of einde) en de groep. Klik vervolgens op 'genereren' om de analyse te starten. Let op! Bij het kiezen van eenzelfde groep en analysemoment wordt de eerder gegenereerde analyse overschreven.",
        textwarning: 'Het genereren van de analyse kan tot 30 minuten duren.',
        select: {
            placeholder: 'Selecteer een toets',
            group_placeholder: 'Selecteer een groep',
            middle: 'Midden',
            end: 'Einde',
            start: 'Begin',
        },
        dialog: {
            confirm: {
                text: 'Weet u zeker dat u de analyse van geselecteerde groep wilt genereren? Let op! Bij het kiezen van eenzelfde groep en analysemoment wordt de eerder gegenereerde analyse overschreven.',
            },
            success: {
                text: 'Analyse van studenten wordt momenteel gegenereerd. Dit kan tot 30 minuten duren.',
            },
        },
        action: {
            run: 'Genereren',
        },
        treatment: {
            title: 'Stimulerende (s) / belemmerende (b) factoren per hoofdgebied',
            area: 'Hoofdgebied',
            description: 'Notitie(s) / analyse:',
        },
    },
    'snackbar': {
        actions: {
            chat: 'Chat',
            roadmap: 'Stappenplan',
            deselect: 'Deselecteren',
            reset_statuses: 'Reset status',
        },
    },
    'summary': {
        title: 'Leerdoelen Overzicht',
        clearStudentStatuses: 'Reset hulp en afgerond status',
        status: 'Verander status leerdoel',
        description: 'Stappenplan',
        message: 'Chat bericht over leerdoel',
        placeholder: 'Acties:',
        view: 'Notitie over leerling',
        open: 'Naar profiel',
        error: 'De gekozen selectie bevat geen leerlingen.',
        treatmentAdd: 'Voeg ondersteuning toe',
        patience: 'Een moment a.u.b..',
        support: 'Probeer het nog een keer of neem contact op met de Helpdesk.',
        dialog: {
            status: {
                title: 'Verander status leerdoel(en)',
                text: 'Verander status voor {length} leerdoelen',
                takingTooLong: 'We zijn bezig om de aanpassingen uit te voeren.',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met de aanpassingen, vermoedelijk is er iets mis gegaan.',
                    },
                    submitted: {
                        title: 'Status leerdoel is voor {length} leerdoelen aangepast.',
                    },
                },
            },
            statusFinalized: {
                title: 'Verander beoordeling leerdoel(en)',
                text: 'Verander beoordeling voor {length} leerdoelen',
                takingTooLong: 'We zijn bezig om de aanpassingen uit te voeren.',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met de aanpassingen, vermoedelijk is er iets mis gegaan.',
                    },
                    submitted: {
                        title: 'Beoordeling leerdoel is voor {length} leerdoelen aangepast.',
                    },
                },
            },
            message: {
                title: 'Laat een chat bericht achter',
                text: 'Laat een bericht achter bij de geselecteerde leerlingen die dit doel hebben uitgelicht. Je plaatst hetzelfde bericht bij elke leerling maar ze kunnen niet als groep reageren .',
                placeholder: 'Bericht',
                takingTooLong: 'We zijn bezig het bericht te plaatsen.',
                send: 'Verstuur',
                alert: {
                    failed: {
                        title: 'We zijn nog steeds bezig met het sturen van je bericht, vermoedelijk is er iets mis gegaan.',
                    },
                    notSelected: {
                        title: 'Één of meerdere van deze doelen heeft geen gele status, dus werkt Mijnberichten niet.',
                        text: 'Pas deze doelen aan naar een gele status om een chatbericht te versturen.',
                    },
                    submitted: 'Er zijn {length} nieuwe berichten geplaatst.',
                },
            },
            description: {
                title: 'Nieuwe stap doorgeven',
                text: 'Kies rechts via de drie puntjes een voorgekozen stap en schrijf een nieuwe voor {length} leerdoel(en)',
                header: 'Stappen',
                takingTooLong: 'Wij zijn bezig met het aanpassen van de volgende stap.',
                placeholder: 'Leg uit wat de volgende stap is.',
                alert: {
                    failed: 'Het aanpassen van de volgende stap duurt wat langer dan normaal. Er is mogelijk iets fout gegaan.',
                    submitted: 'De volgende stap is aangepast voor {length} leerdoel(en).',
                },
            },
        },
    },
    'steps': {
        title: 'Stap | Stappen',
        placeholder: 'Stappen tekst',
    },
    'select_filter': {
        monday: 'maandag',
        tuesday: 'dinsdag',
        wednesday: 'woensdag',
        thursday: 'donderdag',
        friday: 'vrijdag',
        saturday: 'zaterdag',
        sunday: 'zondag',
    },
    'rosterAudits': {
        activity: {
            missing: 'Dit tijdslot heeft nog geen activiteiten.',
        },
        event: {
            missing: 'Deze datumtijdslot heeft nog geen lessen.',
        },
        teacher: {
            absent: '{name} is niet aanwezig voor dit tijdslot.',
            contract: 'Dit tijdslot vindt plaats buiten de contracturen van {name} op {day}.',
            occupied: '{name} is al ingepland voor iets anders op dit tijdslot.',
            vacation: '{name} is niet beschikbaar omdat er vrijgenomen is.',
        },
        group: {
            occupied: 'De groep "{name}" is gekoppeld aan meerdere activiteiten.',
            unassigned: 'Groep "{name}" is nog nergens aan gekoppeld.',
            missing: 'Er zijn nog geen groepen uitgenodigd naar een activiteit.',
            recess: 'Groep "{name}" is ingepland voor een pauze en les tegelijketijd.',
        },
        room: {
            occupied: 'Het lokaal "{name}" is gekoppeld aan meerdere activiteiten.',
        },
        level: {
            occupied: 'Het niveau "{name}" is gekoppeld aan meerdere activiteiten.',
            unassigned: 'Niveau "{name}" is nog nergens aan gekoppeld.',
            missing: 'Er zijn nog geen niveaus uitgenodigd naar een activiteit.',
            recess: 'Niveau "{name}" is ingepland voor een pauze en les tegelijketijd.',
        },
    },
    'logs': {
        title: 'Logs',
        fetch: 'Logs ophalen',
    },
    'yes': 'Ja',
    'no': 'Nee',
    'by': 'door',
    'on': 'op',
    'quillEditor': {
        placeholder: 'Voeg hier je tekst in ...',
    },
    'date': {
        title: 'Datum',
    },
    'finished': {
        comment: 'Omschrijving',
        by_teacher: 'Door',
        finished_on: 'op',
    },
    'uploadNoteDialog': {
        header: 'Upload notitie naar MijnDrive',
        placeholder: 'Titel beschrijving',
    },
    'settings': {
        student: 'Leerling instellingen',
        guardian: 'Ouder instellingen',
        has_roster: {
            title: 'Autoplanner e-mail versturen bij leeg rooster',
            description: 'Verstuur de autoplanner e-mail bij een leeg rooster',
        },
        plp: {
            title: 'Doel op geel zetten',
            description: 'Leerlingen kunnen zelf in het PLP het doel op geel zetten',
        },
        guardian_can_see_student_scooltracker: {
            title: 'Bepalen of je de MijnPLP tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnPLP tab zien',
        },
        guardian_can_see_student_this_is_me: {
            title: 'Bepalen of je de Dit Ben Ik tab voor ouders uit zet',
            description: 'Ouders kunnen de Dit Ben Ik tab zien',
        },
        guardian_can_see_student_portfolio: {
            title: 'Bepalen of je de MijnDrive tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnDrive tab zien',
        },
        guardian_can_see_student_documents: {
            title: 'Bepalen of je de Documenten tab voor ouders uit zet',
            description: 'Ouders kunnen de Documenten tab zien',
        },
        guardian_can_see_student_finished: {
            title: 'Bepalen of je de Successen tab voor ouders uit zet',
            description: 'Ouders kunnen de Successen tab zien',
        },
        guardian_can_see_student_profile: {
            title: 'Bepalen of je de Profiel tab voor ouders uit zet',
            description: 'Ouders kunnen de Profiel tab zien',
        },
        guardian_can_see_student_notes: {
            title: 'Bepalen of je de Notities tab voor ouders uit zet',
            description: 'Ouders kunnen de Notities tab zien',
        },
        guardian_can_see_student_roster: {
            title: 'Bepalen of je de MijnRooster tab voor ouders uit zet',
            description: 'Ouders kunnen de MijnRooster tab zien',
        },
        guardian_can_use_chat_functions: {
            title: 'Bepalen of je de chat functie voor ouders uit zet',
            description: 'Ouders kunnen de chat functies gebruiken bij PLP en bij de MijnBerichten van een leerling',
        },
        guardian_can_see_student_lvs: {
            title: 'Bepalen of je de Analyse tab bij een leerling laat zien voor ouders',
            description: 'Ouder kunnen de Analyse tab zien van een leerling',
        },
        hide_my_roster: {
            title: 'Digitale Klassenmap',
            description: 'Zet deze optie aan om de Digitale Klassenmap te activeren. Onderdeel MijnRooster zal dan niet meer zichtbaar zijn voor leraren en leerlingen.',
        },
        parnassys: {
            brin_number_title: 'Brinnummer',
            brin_number_subtitle: 'Vul hier het brinnummer in van de school',
            guardians_title: 'Synchroniseer ouders',
            guardians_subtitle: 'Als deze instelling aan staat, zullen ouders worden gesynchroniseerd vanuit Parnassys naar in Mijn Leerlijn.',
            teachers_title: 'Synchroniseer leerkrachten',
            teachers_subtitle: 'Als deze instelling aan staat, zullen leerkrachten worden gesynchroniseerd vanuit Parnassys in Mijn Leerlijn.',
            automatic_sync_students_title: 'Automatische synchronisatie studenten',
            automatic_sync_students_subtitle: 'Als deze optie is ingeschakeld, worden studenten elke dag om 07:00 uur automatisch gesynchroniseerd',
            automatic_sync_teachers_title: 'Automatische synchronisatie leraren',
            automatic_sync_teachers_subtitle: 'Als deze optie is ingeschakeld, worden leraren elke dag om 07:00 uur automatisch gesynchroniseerd',
            automatic_sync_guardians_title: 'Automatische synchronisatie Ouders',
            automatic_sync_guardians_subtitle: 'Als deze optie is ingeschakeld, worden ourders elke dag automatisch om 07:00 uur gesynchroniseerd',
        },
        mfa: {
            teachers_title: 'MFA leerkrachten',
            teachers_subtitle: 'Als deze instelling aan staat, zullen leerkrachten moeten inloggen door middel van MFA.',
            students_title: 'MFA leerlingen',
            students_subtitle: 'Als deze instelling aan staat, zullen leerlingen moeten inloggen door middel van MFA',
            guardians_title: 'MFA ouders',
            guardians_subtitle: 'Als deze instelling aan staat, zullen ouders moeten inloggen door middel van MFA',
        },
        group: {
            is_visible_for_students: 'Zichtbaar voor leerlingen',
            new_group_type: 'Nieuw groep type',
            delete_error: 'Kan groeptype niet verwijderen',
        },
    },
    'idp_pdf_download': {
        no_students_found: 'Er is iets fout gegaan tijdens het ophalen van de leerlingen.',
        will_be_sent_by_email: 'De leerlingboekjes worden gegenereerd en per e-mail naar u opgestuurd zodra ze klaar zijn. Dit kan enkele minuten duren.',
        download_successful: 'Klik op de button om het leerlingboekje te openen in een nieuw tabblad',
    },
    'select': {
        project: {
            placeholder: 'Choose a project',
        },
    },
    'skill_set': {
        add: 'Vaardighedenset toevoegen',
        delete: 'Vaardighedenset verwijderen',
        create: 'Vaardighedenset maken',
        create_button: 'Aanmaken',
        edit: 'Vaardighedenset bewerken',
        title: 'Vaardigheden',
        edit_name: 'Voer de nieuwe vaardigheidssetnaam in',
        dialog: {
            select_placeholder: 'Selecteer Vaardigheden',
            select_label: 'Vaardigheden',
            delete_category_warning: 'Weet u zeker dat u deze vaardighedenset wilt verwijderen?',
        },
        alert: {
            text: 'Er zijn nog geen vaardigheden gemaakt.',
            subtext: 'Je kunt er een toevoegen door op de knop te drukken.',
            delete: 'Weet je zeker dat je dit wilt verwijderen?',
        },
        add_skill: 'Vaardigheid toevoegen',
        name_placeholder: 'Typ de naam van een vaardighedenset',
    },
    'subjectSelect': {
        areaText: 'Selecteer een gebied',
        topicText: 'Kies een onderwerp',
    },
    'parnassys': {
        navigation_title: 'Parnassys',
        table: {
            results_found: 'gebruiker | gebruikers',
            headers: {
                name: 'Naam',
                roles: 'Rollen',
                parnassys_id: 'Parnassys ID',
            },
        },
        dialog: {
            no_users_found: 'We hebben geen leerling kunnen vinden. Probeer het opnieuw.',
            step_1: {
                header: 'Gebruikersgegevens',
                title: 'Gebruiker die moet worden gekoppeld',
                subtitle: 'Voer de naam in van de gebruiker die u aan parnassys wilt koppelen',
                find: 'Gebruiker zoeken',
                label: 'Selecteer leerling',
                placeholder: 'Leerling',
            },
            step_2: {
                header: 'Gebruikersselectie',
                title: 'Gebruiker die moet worden gekoppeld',
                subtitle: 'Voer de naam in van de gebruiker die u aan parnassys wilt koppelen',
                success: 'Gebruiker is succesvol gekoppeld',
            },
        },
    },
    'legend': {
        title: 'Legenda',
        description: 'Er is voor deze leerling een stappenplan toegevoegd.',
        open: 'Open de pop-up van het leerdoel van deze leerling.',
        steps: 'De voortgangsbollen van de leerling.',
        project: 'Dit leerdoel is aan een project gekoppeld.',
        help: 'Deze leerling heeft om hulp gevraagd.',
        finished: 'De leerling geeft aan dat het leerdoel behaald is.',
        prio: 'Dit leerdoel heeft prioriteit.',
        descriptions: {
            busy: 'Leerdoel wordt in de huidge periode aangeboden. De leerling heeft nog geen instructie gehad / is nog niet begonnen met leerdoel.',
            highlighted: 'Leerling is aan het werk met het leerdoel.',
            old: 'Leerdoel uit voorgaande periode / niveau. Leerling heeft nog niet aan het leerdoel gewerkt. (Status wordt automatisch toegekend aan leerdoelen met de blauwe status.)',
            inactive: 'Het leerdoel is niet gekoppeld aan de leerling veelal door ander niveau, handmatig verwijdert van het Persoonlijk LeerdoelenPlan.',
            closed: 'Het leerdoel is niet behaald, maar het leerddoel wordt niet verder meer aangeboden.',
            finished: 'Het leerdoel is behaald.',
            future: 'Het leerdoel staat klaar voor de leering voor de volgende periode.',
            dismissed: 'Het leerdoel is handmatig op Niet Van Toepassing gezet door de leerkracht.',
        },
    },
    'navigationCard': {
        student: {
            schoolTracker: 'Bekijk hier de actieve, afgesloten en behaalde leerdoelen op het Persoonlijke LeerdoelenPlan',
            thisIsMe: 'Bekijk hier de persoonlijke ontwikkeling en de vaardigheden',
            portfolio: 'Verzamel en bekijk hier de persoonlijke documenten',
            profile: 'Bekijk hier de persoonlijke informatie, wijzig het wachtwoord, zie welke ouders zijn gekoppeld en van welke groep(en) de leerling lid is',
            messages: 'Lees en stuur hier berichten tussen leerling, ouder(s) en leraren',
            notes: 'Bekijk hier de notities over de ontwikkeling, werkhouding en/of het leerproces',
            treatment: 'Bekijk of beschrijf de ondersteuning voor het versterken van de ontwikkeling, werkhouding en/of het leerproces',
            plan_group: "Bekijk en maak hier evaluaties, handelingsplannen, groeidocumenten, OPP's enz",
            plan: "Bekijk en maak hier evaluaties, handelingsplannen, groeidocumenten, OPP's enz",
            levels: 'Analyseer of het aanbod (PLP) overeenkomst met de resultaten (PLP en LVS)',
            finished: 'Bekijk hier het overzicht de behaalde leerdoelen',
            roster: 'Bekijk het actuele weekrooster of kies lessen voor het komende weekrooster',
        },
        group: {
            profile: 'Bekijk en wijzig hier de naam van de groep, gekoppelde leerkrachten en leerlingen en koppel een doelenset.',
            files: 'Stukje tekst over',
            steps: 'Stukje tekst over',
            messages: 'Lees en stuur berichten naar de leden van de groep.',
            notes: 'Lees en maak notities over de groep.',
            audit: 'Bekijk het logboek van de groep.',
            studentOverview: 'Bekijk het aantal statussen van de groep per leerling en zie hoe de voortgang is ten opzichte van de andere groepsleden. Filter op hoofdgebied, deelgebied, niveau en periode.',
            curriculum: 'Bekijk het aantal actieve leerdoelen per hoofd- en deelgebied van de groepsleden. Zie welke leerdoelen je als leerkracht nog moet organiseren. Genereer vervolgens een Leerdoelenoverzicht om acties uit te voeren.',
            projectPlan: 'Bekijk het plan van de gekoppelde Doelenset (optioneel).',
            report: 'Bekijk en voer de resultaten in van de LVS-toets om een analyse te maken op groepsniveau. Deze resultaten maken het ook mogelijk om voor de leerling een analyse te maken (optioneel).',
            titles: {
                profile: 'GroepsProfiel',
                messages: 'GroepsChat',
                notes: 'GroepsNotities',
                plan: 'DoelensetPlan',
                studentOverview: 'Groepsoverzicht statussen',
                curriculum: 'Groepsoverzicht leerdoelen',
                report: 'GroepsAnalyse',
            },
        },
        project: {
            subjects: 'Voeg de leerdoelen toe vanuit het curriculum aan de doelenset',
            notes: 'Beschrijf de inhoud van de doelenset en/of geef informatie aan de leerkracht over de doelenset / het thema.',
            projectPlan: 'Beschrijf de stappen en/of opdrachten voor de leerling om met de doelenset aan de slag te gaan (optioneel)',
            media: 'Sla bestanden, documenten en media op die passen bij de doelenset / het thema (optioneel)',
            files: 'Stukje tekst over',
            messenger: 'Communiceer met leerlingen en/of leerkrachten over de doelenset / het thema.',
            titles: {
                messenger: 'DoelensetChat',
            },
        },
    },
    'worksheet': {
        title: 'Keuzeformulier aanmaken werkblad',
        newWorksheet: 'Nieuw werkblad',
        openWorksheet: 'Open werkblad',
        downloadWorksheet: 'Download werkblad',
        succesMessage: 'Het werkblad is succesvol gegenereerd.',
        sumOptions: 'Som opties',
        reviewOptions: 'Nakijk opties',
        addendum: 'Toelichting',
    },
    'app_offline_title': 'Applicatie niet bereikbaar',
    'app_offline_subtitle': 'De applicatie is op dit moment niet bereikbaar, probeer de pagina te herladen.',
    'app_offline_button_reload': 'Probeer opnieuw',
    'choose_area': 'Kies Gebied',
    'choose_topic': 'Kies Deelgebied',
    'status': 'Aantallen',
    'insights': 'Inzicht',
    'student_overview': 'Studentenoverzicht',
    'prioritise': 'MijnVoorrang',
    'deprioritise': 'Geen voorrang',
    'prioritised': 'MijnVoorrang',
    'no_schools_connected': 'Geen scholen gekoppeld',
    'admin_dashboard_description': 'Dit is het dashboard van het adminportaal van MijnLeerlijn. Hier kun je accounts en scholen beheren.',
    'access_to_all_schools': 'Toegang tot alle scholen',
    'parnassys_name': 'Parnassys naam',
    'reset_mfa': 'Reset 2FA code voor gebruiker',
    'is_primary': 'Is primair',
    'user_text': 'Gebruiker',
    'group_text': 'Groep',
    'student_text': 'Leerling',
    'Remove {item}': '{item} verwijderen',
    'Update Available': 'Update beschikbaar',
    'A new release has been made available.': 'Een nieuwe versie van de applicatie is beschikbaar.',
    'Working with an old version may cause unexpected issues.': 'Het werken met een oude versie van de applicatie kan onverwachte problemen opleveren.',
    'Refresh Application': 'Applicatie verversen',
    'hide notification': 'melding verbergen',
    'Manually Refresh': 'Handmatig verversen',
    'When done with your work please close this window; or, refresh the page by using CTRL + F5 on a Windows device or CMD + R on an iOS (Apple) device.': 'Als je klaar bent sluit dan het venster, of ververs zelf de pagina door CTRL + F5 te gebruiken op een Windows machine of CMD + R op aan iOS (Apple) machine.',
    'Close': 'Sluiten',
    'The maximum file size is 7MB': 'De maximale bestandsgrootte is 7MB',
    'The maximum file size is exceeded': 'De maximale bestandsgrootte is overschreden',
    'Lesson plan generator': 'Lesplan generator',
    'Amount of areas': 'Aantal hoofdgebieden',
    'Areas': 'Hoofdgebieden',
    'Tag category': 'Tag categorie',
    'Graduation profile': 'Hoofdgebiedprofiel',
    'Graduation profiles': 'Hoofdgebiedprofielen',
    'Area': 'Hoofdgebied',
    'Amount of topics': 'Aantal deelgebieden',
    'Add graduation profile': 'Hoofdgebiedprofiel toevoegen',
    'Create graduation profile': 'Hoofdgebiedprofiel aanmaken',
    'Edit graduation profile': 'Hoofdgebiedprofiel aanpassen',
    'Topics': 'Deelgebieden',
    'Topic': 'Deelgebied',
    'Tag categories': 'Tag categorieën',
    'Select a category': 'Selecteer een categorie',
    'All tag categories': 'Alle tag categorieën',
    'All graduation profiles': 'Alle hoofdgebiedprofielen',
    'Group actions': 'Groep acties',
    'Assign graduation profile': 'Koppel hoofdgebiedprofiel',
    'Select all': 'Selecteer alles',
    'Unselect all': 'Deselecteer alles',
    'Select graduation profile': 'Selecteer hoofdgebiedprofiel',
    'Select students': 'Selecteer leerlingen',
    'Select student': 'Selecteer leerling',
    'Select PLP': 'Selecteer PLP',
    'Attach': 'Koppelen',
    'Students': 'Leerlingen',
    'Action completed': 'Actie voltooid',
    'Action completed successfully': 'Actie succesvol uitgevoerd',
    'Attach graduation profile': 'Koppel hoofdgebiedprofiel',
    'A graduation profile contains all areas and topics that are part of the graduation profile. By attaching a profile to one or more students, all areas are asigned at once.': 'Een hoofdgebiedprofiel bevat hoofd- en deelgebieden. Door een hoofdgebiedprofiel te kopellen aan één of meerdere leerlingen, koppel je in een keer de juiste hoofd- en deelgebieden.',
    'Actions': 'Acties',
    'Below you find a list of actions that can be executed for a group.': 'Hieronder vind je een overzicht van de acties die je kunt uitvoeren.',
    'The student booklets are generated and emailed to you as soon as they are ready. This may take several minutes.': 'De leerlingboekjes worden gegenereerd en per e-mail naar u opgestuurd zodra ze klaar zijn. Dit kan enkele minuten duren.',
    'Attention: any assigned goals will be marked inactive. Are you sure that you want to delete this {item}? | Are you sure that you want to delete these {item}?': 'Let op: eerder toegewezen doelen zullen op inactief worden gezet. Weet je zeker dat je dit {item} wilt verwijderen? | Weet je zeker dat je deze {item} wilt verwijderen?',
    'Select a graduation profile': 'Selecteer een hoofdgebiedprofiel',
    'Portfolio label': 'Portfolio label',
    'Add tag category': 'Tag categorie toevoegen',
    'Edit tag category': 'Tag categorie aanpassen',
    'Add tag': 'Tag toevoegen',
    'Edit tag': 'Tag aanpassen',
    'Save': 'Opslaan',
    'Add goals to PLP': 'Doelen toevoegen aan PLP',
    'Add skill set': 'Voeg vaardighedenset toe',
    'Add document to student': 'Document toevoegen aan leerling',
    'Add document to group': 'Document toevoegen aan groep',
    'Add document to project': 'Document toevoegen aan doelenset',
    'Download "This is me"': '"Dit ben ik" downloaden',
    'Select skill set': 'Selecteer vaardighedenset',
    'Basic information': 'Basisinformatie',
    'Content': 'Inhoud',
    'On this page you can quickly perform actions for one student, multiple students or the entire group.': 'Op deze pagina kun je snel acties uitvoeren voor één leerling, meerdere leerlingen of de hele groep.',
    'Link a graduation profile to one or more students. They will then be automatically linked to the corresponding sub-areas and learning objectives. Note: learning objectives that are still linked to the "old" graduation profile will be set to inactive.': 'Koppel een hoofdgebiedprofiel aan één of meerdere leerlingen. Zij worden dan automatisch gekoppeld aan de bijbehorende deelgebieden en leerdoelen. Let op: leerdoelen die nog gekoppeld zijn aan het ‘oude’ hoofdgebiedprofiel worden op inactief gezet.',
    'Use this button to automatically generate learning objectives for students who are linked to a main and/or sub-area, but for whom the objectives are not yet visible in the PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.': 'Gebruik deze knop om automatisch leerdoelen te genereren voor leerlingen die wel aan een hoofd- en/of deelgebied zijn gekoppeld, maar bij wie de doelen nog niet zichtbaar zijn in het PLP. Let op: het kan zijn dat de leerdoelen al op ‘behaald’ of ‘gesloten’ staan en daarom niet zichtbaar zijn. Zet in dat geval de statussen ‘behaald’ en ‘gesloten’ aan in de filter om ze zichtbaar te maken.',
    'Use this button when one or more students are linked to a goal set, but the learning objectives are not visible in their PLP. Note: it may be that the learning objectives are already set to "achieved" or "closed" and therefore not visible. In that case, turn on the statuses "achieved" and "closed" in the filter to make them visible.': 'Gebruik deze knop wanneer één of meerdere leerlingen wel aan een doelenset gekoppeld zijn, maar de leerdoelen niet zichtbaar zijn in hun PLP. Let op: het kan zijn dat de leerdoelen al op ‘behaald’ of ‘gesloten’ staan en daarom niet zichtbaar zijn. Zet in dat geval de statussen ‘behaald’ en ‘gesloten’ aan in de filter om ze zichtbaar te maken.',
    'Remove learning objectives from the PLP of one student or the entire group.': 'Verwijder leerdoelen uit het PLP van één leerling of van de hele groep.',
    'Select students to receive their learning objectives booklets by email.': 'Selecteer leerlingen om hun leerdoelenboekjes per e-mail te ontvangen.',
    'Add learning objectives to PLP': 'Voeg leerdoelen toe aan PLP',
    'Select students and manually add learning objectives to their PLP.': 'Selecteer leerlingen en voeg handmatig leerdoelen toe aan hun PLP.',
    'Select one or more skill sets and link them to one or more students. These will then be displayed on the "this is me" page of the student.': 'Selecteer één of meerdere vaardighedensets en koppel deze aan één of meerdere leerlingen. Deze staan dan bij de leerling op de “dit ben ik” pagina.',
    'Add document to a student': 'Voeg document toe aan een leerling',
    'Create a document for a specific student.': 'Maak een document aan voor een specifieke leerling.',
    'Add document to a group': 'Voeg document toe aan een groep',
    'Create a document for the entire group.': 'Maak een document aan voor de gehele groep.',
    'Download "This is me" in portfolio': 'Download “Dit ben ik” in portfolio',
    'Select one or more students, give the document a name, and download it in the portfolio archive on the "this is me" page.': 'Selecteer één of meerdere leerlingen, geef het document een naam, en download het in het portfolio-archief bij de “Dit ben ik”-pagina.',
    'Subject label': 'Leerdoel tag',
    'Subject labels': 'Leerdoel tags',
    'Add subject label': 'Leerdoel tag toevoegen',
    'Status sets': 'Status sets',
    'Create status set': 'Status set aanmaken',
    'Edit status set': 'Status set aanpassen',
    'Status labels': 'Status labels',
    'Are you sure that you want to delete {item}?': 'Weet je zeker dat je {item} wilt verwijderen?',
    'Created at': 'Aangemaakt op',
    'Default': 'Standaard',
    'On this page you find an overview of all the students in the group.': 'Op deze pagina vind je een overzicht van alle leerlingen in de groep.',
    'Student overview': 'Leerlingenoverzicht',
    'Select area': 'Selecteer hoofdgebied',
    'Assign goal set': 'Koppel doelenset',
    'Results from current year': 'Resultaten uit het huidige jaar',
    'Results from the past year': 'Resultaten uit het verleden',
    'All results': 'Alle resultaten',
    'To view results from all years, first set the filters above for level and period.': 'Om resultaten van alle jaren te bekijken moet eerst een waarde worden gekozen voor niveau en periode in de filters hierboven.',
    'Select which area you want to change the level and period for.': 'Selecteer het hoofdgebied waarvoor je het niveau en de periode wilt wijzigen.',
    'Period': 'Periode',
    'Level': 'Niveau',
    'Change level and/or period': 'Wijzig niveau en/of periode',
    'Select the area for which you want to change the level and/or period. Then change the level and/or period for the students in this area.': 'Selecteer het hoofdgebied waarvoor je het niveau en/of de periode wilt wijzigen. Wijzig vervolgens het niveau en/of de periode voor de leerlingen in dit hoofdgebied.',
    'Select the area for which you want to change the level and/or period.': 'Selecteer het hoofdgebied waarvoor je het niveau en/of de periode wilt wijzigen.',
    'Cancel': 'Annuleren',
    'The levels and/or periods have successfully been updated.': 'De niveaus en/of periodes zijn succesvol bijgewerkt.',
    'Age': 'Leeftijd',
    'Student name': 'Naam leerling',
    'Action': 'Actie',
    'Select the area for which you want to change the graduation profile and then update the profile.': 'Selecteer het hoofdgebied waarvoor je het hoofdgebiedprofiel wilt wijzigen en werk vervolgens het profiel bij.',
    'Select the area for which you want to change the graduation profile.': 'Selecteer het hoofdgebied waarvoor je het hoofdgebiedprofiel wilt wijzigen.',
    'Confirm': 'Bevestigen',
    'Do you want to disable the the current attached graduation profile or do you want to keep it active?': 'Wil je het huidige gekoppelde hoofdgebiedprofiel uitschakelen of wil je het actief houden?',
    'Keep active': 'Houd actief',
    'Disable': 'Uitschakelen',
    'No graduation profiles found for this area': 'Geen hoofdgebiedprofielen gevonden voor dit hoofdgebied',
    'Create new skill sets or edit and delete existing ones.': 'Maak nieuwe vaardighedensets aan of bewerk en verwijder bestaande sets.',
    'Skill set': 'Vaardighedenset',
    'Change the level and/or period for all students on the selected topic.': 'Wijzig het niveau en/of de periode voor alle leerlingen in het geselecteerde deelgebied.',
    'Selected topic': 'Geselecteerd deelgebied',
    'Selected student': 'Geselecteerde leerling',
    'Change the level and/or period for all the topics for the selected student.': 'Wijzig het niveau en/of de periode voor alle deelgebieden voor de geselecteerde leerling.',
    'Assign a new graduation profile and override or keep existing profiles.': 'Koppel een nieuw hoofdgebiedprofiel en overschrijf of behoud bestaande profielen.',
    'Current goal set(s)': 'Huidige doelenset(s)',
    'No data available for the selected area': 'Geen gegevens beschikbaar voor het geselecteerde hoofdgebied',
    'Apply filters': 'Filters toepassen',
    'No rating yet': 'Nog geen beoordeling',
    'Select a graduation profile to assign to all the current selected students.': 'Selecteer een hoofdgebiedprofiel om toe te wijzen aan alle geselecteerde leerlingen.',
    'Do you wish to disable the currently attached goals while assigning a new graduation profile or do you wish to keep these active?': 'Wil je de huidige gekoppelde doelen uitschakelen bij het toewijzen van een nieuw hoofdgebiedprofiel of wil je deze actief houden?',
    'Manage level and period': 'Beheer niveau en periode',
    'Manage graduation profiles': 'Beheer hoofdgebiedprofielen',
    'Manage goal sets': 'Beheer doelensets',
    'Manage skill sets': 'Beheer vaardighedensets',
    'Assign skill sets to students and/or edit existing skill ratings.': 'Koppel vaardighedensets aan leerlingen en/of bewerk bestaande vaardigheidsbeoordelingen.',
    'No skill set added yet': 'Nog geen vaardighedenset toegevoegd',
    'No graduation profile assigned yet': 'Nog geen hoofdgebiedprofiel toegewezen',
    'Do you wish all topics that are not relevant for the selected graduation profile to be set to inactive, or do you wish to keep them active?': 'Wil je dat alle deelgebieden die niet relevant zijn voor het geselecteerde hoofdgebiedprofiel op inactief worden gezet, of wil je ze actief houden?',
    'Add or edit current goal sets for students.': 'Voeg doelensets toe of bewerk huidige doelensets voor leerlingen.',
    'Select a goal set': 'Selecteer een doelenset',
    'Either change the goal sets for all selected students or add and/or edit a goal set for specific students.': 'Wijzig de doelensets voor alle geselecteerde leerlingen of voeg een doelenset toe en/of bewerk een doelenset voor specifieke leerlingen.',
    'Select a goal set for all selected students.': 'Selecteer een doelenset voor alle geselecteerde leerlingen.',
    'Edit the goal sets for the selected student.': 'Bewerk de doelensets voor de geselecteerde leerling.',
    'Add a goal set for the selected student.': 'Voeg een doelenset toe voor de geselecteerde leerling.',
    'Do you wish to disable the currently attached goal set(s) while assigning a new goal set or do you wish to keep these active?': 'Wil je de huidige gekoppelde doelenset(s) uitschakelen bij het toewijzen van een nieuwe doelenset of wil je deze actief houden?',
    'No goal sets assigned yet': 'Nog geen doelensets toegewezen',
    'Goal set(s)': 'Doelenset(s)',
    'Select a graduation profile for all selected students.': 'Selecteer een hoofdgebiedprofiel voor alle geselecteerde leerlingen.',
    'Edit the graduation profile for the selected student.': 'Bewerk het hoofdgebiedprofiel voor de geselecteerde leerling.',
    'Add a graduation profile for the selected student.': 'Voeg een hoofdgebiedprofiel toe voor de geselecteerde leerling.',
    'No skill added yet': 'Nog geen vaardigheid toegevoegd',
    'No rating provided yet': 'Nog geen beoordeling gegeven',
    'Assign a new skill set.': 'Koppel een nieuwe vaardighedenset.',
    'Edit skill rating': 'Beoordeel vaardigheid',
    'Select level': 'Selecteer niveau',
    'Select period': 'Selecteer periode',
    'N/A': 'N.v.t.',
    'Generate': 'Genereren',
    'Add': 'Toevoegen',
    'Download': 'Downloaden',
    'Delete': 'Verwijderen',
    'Are you sure you want to delete this skill set from the user?': 'Weet je zeker dat je deze vaardighedenset van de gebruiker wilt verwijderen?',
    'Change the level and/or period for all students for all topics at once.': 'Wijzig het niveau en/of de periode voor alle leerlingen voor alle deelgebieden in één keer.',
    'There still area actives goals for the student(s), do you wish to keep these active or should they be deactivated and should only the new goals be prepared?': 'Er staan nog doelen actief bij de leerling(en), wil je dat ik deze behoud of moeten deze op inactief gezet worden en enkel de nieuw gekoppelde doelen klaar gezet worden?',
    'Select a student': 'Selecteer een leerling',
    'Choose student': 'Kies leerling',
    'Sort by': 'Sorteren op',
    'Sort by age': 'Sorteer op leeftijd',
    'If there still are goals active for the student from the goal set(s) which you now remove, do you wish to keep these active or should they be deactivated and should only the new goals be prepared?': 'Als er nog doelen op actief staan bij de leerling van doelensets die je nu uitzet, wil je dat ik deze behoud of moeten deze op inactief gezet worden en enkel de nieuw gekoppelde doelen klaar gezet worden?',
    'Select a goal set to add for all selected students.': 'Selecteer een doelenset om toe te voegen voor alle geselecteerde leerlingen.',
    'Years': 'Jaar',
    'This is me': 'Dit ben ik',
    'Are you sure you want to unlink this goal set?': 'Weet je zeker dat je deze doelenset wilt ontkoppelen',
    'This is me label': 'Dit ben ik label',
    'This is you label': 'Dit ben jij label',
    'Photo album label': 'Foto album label',
    'Student label': 'Leerling label',
    'Unlink': 'Ontkoppelen',
    'Teacher label': 'Leraar label',
    'Parent label': 'Ouder label',
    'At least one tag': 'Minimaal één tag',
    'All selected tags': 'Alle geselecteerde tags',
    'Has admin rights': 'Heeft admin rechten',
    'Admin view enabled': 'Admin weergave ingeschakeld',
    'No results': 'Geen resultaten',
    'Goal set category': 'Doelenset categorie',
    'Goal set categories': 'Doelenset categorieën',
    'Amount of goal sets': 'Aantal doelensets',
    'All goal set categories': 'Alle doelenset categorieën',
    'Add goal set category': 'Doelenset categorie toevoegen',
    'Edit goal set category': 'Doelenset categorie aanpassen',
    'Created by': 'Aangemaakt door',
    'Evaluation': 'Evaluatie',
    'Monday': 'Maandag',
    'Tuesday': 'Dinsdag',
    'Wednesday': 'Woensdag',
    'Thursday': 'Donderdag',
    'Friday': 'Vrijdag',
    'Enter text here...': 'Voer hier tekst in...',
    'Insert column right': 'Kolom rechts invoegen',
    'Insert column left': 'Kolom links invoegen',
    'Insert row up': 'Rij boven invoegen',
    'Insert row down': 'Rij onder invoegen',
    'Delete column': 'Verwijder kolom',
    'Delete row': 'Verwijder rij',
    'Delete table': 'Verwijder tabel',
    'No files found': 'Geen bestanden gevonden',
    'No portfolio archives found': 'Geen portfolio archieven gevonden',
    'Include steps': 'Stappen meenemen',
    'Select for which selected area you wish to include the steps.': 'Selecteer voor welk geselecteerd hoofdgebied je de stappen wilt meenemen.',
    'Select statuses': 'Selecteer statussen',
    'Select which statuses you wish to include in the download.': 'Selecteer welke statussen je wilt meenemen in de download.',
    'Add text field': 'Tekstveld toevoegen',
    'My goal set categories': 'Mijn doelenset categorieën',
    'Goal sets': 'Doelensets',
    'Edit goal set': 'Doelenset aanpassen',
    'Provide feedback on the project': 'Geef feedback op de doelenset',
    'Evaluation successfully saved': 'Evaluatie succesvol opgeslagen',
    'Files': 'Bestanden',
    'Documents': 'Documenten',
    'Goal set document': 'Doelenset document',
    'Goal set documents': 'Doelenset documenten',
    'View': 'Inzien',
    'View and edit': 'Inzien en wijzigen',
    'Curriculum': 'Curriculum',
    'Add document to {item}': 'Document toevoegen aan {item}',
    'Edit document for {item}': 'Document aanpassen voor {item}',
    'Add document': 'Document toevoegen',
    'Edit document': 'Document aanpassen',
    'Success': 'Succes',
    'Document successfully added': 'Document succesvol toegevoegd',
    'Document successfully edited': 'Document succesvol aangepast',
    'No evaluation added yet.': 'Nog geen evaluatie toegevoegd.',
    'Goal set': 'Doelenset',
    'Unknown': 'Onbekend',
    'Category': 'Categorie',
    'Add or read the evaluation of the goal set': 'Zet of lees hier de evaluatie van de doelenset',
    'Add or read the goal set plan': 'Zet of lees hier het plan van de doelenset',
    'Add or view files related to the goal set': 'Bekijk of voeg hier bestanden toe die bij de doelenset horen',
    'Create your goal set here': 'Maak hier je doelenset plan aan',
    'Document type': 'Document type',
    'Document item': 'Document item',
    'Group': 'Groep',
    'Student': 'Leerling',
    'Assigned projects': 'Gekoppelde doelensets',
    'On this page you can quickly view all assigned goal sets to the group as a whole. Note: not all students from the group are assigned to the same goal set.': 'Op deze pagina kun je snel het menu gebruiken van de doelensets die aan de groep gekoppeld zijn. Let op: niet alle leerlingen in de groep hoeven aan dezelfde doelenset gekoppeld te zijn.',
    'No goal sets assigned yet to students in this group.': 'Nog geen doelensets gekoppeld aan de leerlingen in deze groep.',
    'Here you can see the menu with all goal sets that are assigned to this group.': 'Hier zie je het menu met alle doelensets die aan jouw groep gekoppeld zijn.',
    'Personal': 'Persoonlijk',
    'Back to my account': 'Terug naar eigen account',
    'Select amount': 'Selecteer aantal',
    'General': 'Algemeen',
    'Select a goal set to remove for all selected students.': 'Selecteer een doelenset om te verwijderen voor alle geselecteerde leerlingen.',
    'If there still are goals active for the students from the goal set(s) which you now remove, do you wish to keep these active or should they be deactivated?': 'Als er nog doelen actief zijn voor de leerlingen van de doelenset(s) die je nu verwijdert, wil je deze dan actief houden of moeten ze worden gedeactiveerd?',
    'Select goal sets to remove': 'Selecteer doelensets om te verwijderen',
    'It can take up to 7 or 10 minutes to receive the downloaded items in your mailbox. If not, double check you SPAM folder or the helpdesk.': 'Het kan tot 7 of 10 minuten duren voordat je de gedownloade items in je mailbox ontvangt. Controleer anders je SPAM-map of neem contact op met de helpdesk.',
    'Groups': 'Groepen',
    'Here you can plan your daily or weekly goals.': 'Hier kun je je dagelijkse of wekelijkse doelen plannen.',
    'Goals': 'Doelen',
    'Birthdays': 'Verjaardagen',
    'Add week template': 'Voeg week sjabloon toe',
    'Add day template': 'Voeg dag sjabloon toe',
    'Logbook': 'Logboek',
    'Templates': 'Sjablonen',
    'Day': 'Dag',
    'Week': 'Week',
    'Template type': 'Sjabloon type',
    'Select template type': 'Selecteer sjabloon type',
    'Select type': 'Selecteer type',
    'All templates': 'Alle sjablonen',
    'My templates only': 'Alleen mijn sjablonen',
    '{item} goals added': '{item} doelen toegevoegd',
    'All goals': 'Alle doelen',
    'Not previously planned goals': 'Niet eerder geplande doelen',
    '1 goal added': '1 doel toegevoegd',
    'No goals assigned to this timeslot yet': 'Nog geen doelen toegewezen aan dit tijdslot',
    'Only show goals that are not yet planned': 'Toon alleen niet geplande doelen',
    'Show previously planned goals': 'Toon eerder geplande doelen',
    'No active goals found': 'Geen actieve doelen gevonden',
    'Delete timeslot': 'Verwijder tijdslot',
    'Today there are no birthdays': 'Vandaag zijn er geen verjaardagen',
    'Notes': 'Notities',
    'Note': 'Notitie',
    'Add note': 'Notitie toevoegen',
    'Enter a note': 'Voer een notitie in',
    'No notes for today': 'Nog geen notities voor vandaag',
    'Edit': 'Bewerken',
    'Mo.': 'Ma.',
    'Tu.': 'Di.',
    'We.': 'Wo.',
    'Th.': 'Do.',
    'Fr.': 'Vr.',
    'Sa.': 'Za.',
    'Su.': 'Zo.',
    'Do you want to repeat this note on specific days of the week?': 'Wil je deze notitie herhalen op specifieke dagen van de week?',
    'Apply': 'Toepassen',
    'Repeat note': 'Herhaal notitie',
    'Repeat on': 'Herhaal op',
    'End repeat': 'Einde herhaling',
    'This note has recurring settings. Do you want to delete only this occurrence or all occurrences?': 'Deze notitie heeft terugkerende instellingen. Wil je alleen deze notitie verwijderen of alle notities?',
    'Delete all occurrences': 'Verwijder alle notities',
    'This occurrence only': 'Alleen deze notitie',
    'Period planner': 'Periodeplanner',
    'Period planner template': 'Periodeplanner sjabloon',
    'Period planner templates': 'Periodeplanner sjablonen',
    'Add period planner template': 'Voeg periodeplanner sjabloon toe',
    'Add period planner templates': 'Voeg periodeplanner sjablonen toe',
    'Edit period planner template': 'Bewerk periodeplanner sjabloon',
    'Select period planner template': 'Selecteer periodeplanner sjabloon',
    'Add period planner timeslot': 'Voeg periodeplanner tijdslot toe',
    'Edit period planner timeslot': 'Bewerk periodeplanner tijdslot',
    'Add a note for this timeslot': 'Voeg een notitie toe voor dit tijdslot',
    'To goal overview': 'Naar doelen overzicht',
    'Save note': 'Notitie opslaan',
    'Saved': 'Opgeslagen',
    'Unsaved changes': 'Niet opgeslagen',
    'Saved bookmarks': 'Opgeslagen links',
    'My Messages': 'Mijn berichten',
    'My favorites': 'Mijn favorieten',
    'Selected group': 'Geselecteerde groep',
    'Delete saved bookmark': 'Opgeslagen link verwijderen',
    'Edit saved bookmark': 'Bewerk opgeslagen link',
    'Create saved bookmark': 'Link opslaan',
    'Saving changes': 'Wijzigingen opslaan',
    'Creating bookmark': 'Link aanmaken',
    'Created bookmark': 'Link aangemaakt',
    'Edited bookmark': 'Link bewerkt',
    'Note successfully saved': 'Notitie succesvol opgeslagen',
    'Favourite teacher items': 'Favoriete leraar items',
    'Dashboard favoriet': 'Dashboard favoriet',
    'Zichtbaar bij groep': 'Zichtbaar bij groep',
    'Selected school': 'Geselecteerde school',
    'This might take a while...': 'Dit kan even duren...',
    'Use another school to fill the contents of the new school': 'Gebruik een andere school om de inhoud van de nieuwe school te vullen',
    'Select school': 'Selecteer school',
    'Select a color': 'Selecteer een kleur',
    'View notes': 'Bekijk notities',
    'View statusses': 'Bekijk statussen',
    'Edit notes': 'Notities bijwerken',
    'Add a note...': 'Voeg een notitie toe...',
    'Written by {item}, on {date}': 'Geschreven door {item}, op {date}',
    'Cancel editing': 'Bewerken annuleren',
    'Edit note': 'Notitie bewerken',
    'Add note to selected goals': 'Notitie toevoegen aan geselecteerde doelen',
    'Selected goals': 'Geselecteerde doelen',
    'Selected students': 'Geselecteerde leerlingen',
    'No notes yet': 'Nog geen notities',
    'Add note for all students': 'Notitie toevoegen voor alle leerlingen',
    'Select subjects': 'Selecteer leerdoelen',
};
export default translation;
